import HARDCODE from '../../../business-const/HardCode/HardCode'

import MESSAGE from '../../../business-const/Message/Message'

import {
    obtemTextoArray,
    indexCampoComecaTerminaComNumero,
    indexTexto,
    agruparLinhasTextoAgrupar,
} from '../../../business-components/Array/Array'

import {
    dataAtual,
    ano,
    mes,
    dia,
    dataAnoMesDia,
} from '../../../business-components/Date/Date'

import {
    round
} from '../../../business-components/round/round'

//import {
//    espacoAntes,
//} from '../../../business-components/Formata/Formata'

import {
    pesquisaIndexList,
} from '../../../business-rules/List/ListService'

import {
    calculaValorAnual,
} from '../cliente-form/ClienteService'

import {
    trataTexto,
    trataValorTexto,
    trataData,
} from '../cliente-form/ClienteServiceImportacao'

import {
    espaco,
    fimLinha,
    barraData,
    identificaTipoCoberturaSeguroVida,
    //identificaStatusCobertura,
    indexAtualJsonRegistros,
    obtemDadoPDF,
    obtemDadoPDFAnterior,
    obtemDadoXLSX,
    obtemDadoPDFAvulso,
    indexPDFAvulso,
    timeSeguradora,
    idAgenteTimeSeguradora,
    converterCnpjEmpresa,
    jsonRegistrosInicializacao,
    jsonRegistrosJsonRegistrosInicializacao,
    jsonRegistrosJsonRegistrosAtualizaErros,
    incluiCoberturas,
    numeroCotacaoAutomatico,
    incluiTabelaEvolucaoValorResgateCoberturaVidaInteira,
} from './IntegracaoClienteArquivoService'



export const importaPropostaMetLife = (PDFTxt, idUsuarioLogado, vars, equipeList, linhaIntegracao, seguradora,
    nomeArquivo, erros, variaveisGlobais) => {

    const jsonRegistros = jsonRegistrosInicializacao()

    jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

    const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

    if (
            PDFTxt.indexOf(fimLinha + 'Doenças Graves e' + espaco) !== -1 &&
            PDFTxt.indexOf(fimLinha + 'Procedimentos' + fimLinha + 'Cirúrgicos' + fimLinha) !== -1
    ) {

        PDFTxt = PDFTxt.replace(fimLinha + 'Doenças Graves e' + espaco, 
            fimLinha + 'Doenças Graves e Procedimentos Cirúrgicos' + espaco)
        PDFTxt = PDFTxt.replace(fimLinha + 'Procedimentos' + fimLinha + 'Cirúrgicos' + fimLinha, fimLinha)
    }

    if (
            PDFTxt.indexOf(fimLinha + 'Doenças Graves e' + espaco) !== -1 &&
            PDFTxt.indexOf(fimLinha + 'Procedimentos' + fimLinha + 'Cirúrgicos Premium' + fimLinha) !== -1
    ) {

        PDFTxt = PDFTxt.replace(fimLinha + 'Doenças Graves e' + espaco, 
            fimLinha + 'Doenças Graves e Procedimentos Cirúrgicos' + espaco)
        PDFTxt = PDFTxt.replace(fimLinha + 'Procedimentos' + fimLinha + 'Cirúrgicos Premium' + fimLinha, fimLinha)
    }
    
    if (
            PDFTxt.indexOf(fimLinha + 'Diária por Internação' + espaco) !== -1 &&
            PDFTxt.indexOf(fimLinha + 'Hospitalar' + fimLinha) !== -1
    ) {

        PDFTxt = PDFTxt.replace(fimLinha + 'Diária por Internação' + espaco, 
            fimLinha + 'Diária por Internação Hospitalar' + espaco)
        PDFTxt = PDFTxt.replace(fimLinha + 'Hospitalar' + fimLinha, fimLinha)
    }


    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Proposta de Contratação de seguro de vida' + fimLinha + 'N.°' + espaco, fimLinha,
        HARDCODE.importacaoNumeroProposta, true, null, erros, nomeArquivo)

    jsonRegistros.jsonRegistros[indexJsonRegistros].statusProposta = HARDCODE.idStatusPropostaPendente

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Nome do proponente (completo e sem abreviações)' + fimLinha, fimLinha,
        HARDCODE.importacaoNomeSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'CPF (preenchimento obrigatório)' + fimLinha, fimLinha, 
        HARDCODE.importacaoCpfSeguradoCliente, true, null, erros, nomeArquivo)
    
    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Data de nascimento' + fimLinha, fimLinha, 
        HARDCODE.importacaoNascimentoSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Sexo' + fimLinha, fimLinha,
        HARDCODE.importacaoSexoSeguradoCliente, true, null, erros, nomeArquivo)
        
    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Profissão / ocupação profissional' + fimLinha, fimLinha,
        HARDCODE.importacaoProfissaoSegurado, true, null, erros, nomeArquivo)

    if (PDFTxt.indexOf('Endereço completo (rua, número e complemento) - Tipo de endereço: Residencial') !== -1) {
        
        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Endereço completo (rua, número e complemento) - Tipo de endereço: Residencial' + fimLinha,
            fimLinha, HARDCODE.importacaoEnderecoSeguradoCliente, true, null, erros, nomeArquivo)
    
    } else {

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Endereço completo (rua, número e complemento) - Tipo de endereço: Comercial' + fimLinha,
            fimLinha, HARDCODE.importacaoEnderecoSeguradoCliente, true, null, erros, nomeArquivo)
    }

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Bairro' + fimLinha, fimLinha,
        HARDCODE.importacaoBairroSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Cidade' + fimLinha, fimLinha,
        HARDCODE.importacaoCidadeSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'UF' + fimLinha, fimLinha,
        HARDCODE.importacaoUfSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'CEP' + fimLinha, fimLinha,
        HARDCODE.importacaoCepSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Telefone celular (Cód. País + Cód.' + fimLinha + 'Cidade + Telefone):' + fimLinha,
        fimLinha, HARDCODE.importacaoCelularSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Email' + fimLinha, fimLinha,
        HARDCODE.importacaoEmailSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Bruto (R$)Nome Prazo' + fimLinha,
        fimLinha + 'Coberturas Adicionais do Seguro (exceto para os produtos MetLife Vida Empresarial Total e MetLife Vida' + fimLinha,
            HARDCODE.importacaoPropostaCoberturas, true, null, erros, nomeArquivo)
    
    const coberturaBasica = jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas
    
    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Prêmio' + fimLinha + 'Bruto (R$)',
        fimLinha + 'Total' + espaco,
            HARDCODE.importacaoPropostaCoberturas, false, null, erros, nomeArquivo)

    jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas = coberturaBasica +
        (
            jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas
                ?
                    fimLinha + jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas
                :
                    ''
        )

    if (PDFTxt.indexOf('[x] Mensal') !== -1) {

        jsonRegistros.jsonRegistros[indexJsonRegistros].tipoPeriodicidadePagtoPremio = HARDCODE.idTipoPeriodicidadeMensal

    } else {

        jsonRegistros.jsonRegistros[indexJsonRegistros].tipoPeriodicidadePagtoPremio = HARDCODE.idTipoPeriodicidadeAnual
    }

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'um token em' + fimLinha, espaco,
        HARDCODE.importacaoDataAssinatura, false, null, erros, nomeArquivo)

    if (!jsonRegistros.jsonRegistros[indexJsonRegistros].dataAssinatura) {

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Assinado pelo' + fimLinha + 'proponente através' + fimLinha +
            'de biometria facial' + fimLinha + 'em' + espaco, fimLinha,
                HARDCODE.importacaoDataAssinatura, false, null, erros, nomeArquivo)

        if (!jsonRegistros.jsonRegistros[indexJsonRegistros].dataAssinatura) {

            jsonRegistros.jsonRegistros[indexJsonRegistros].dataAssinatura = dataAtual()
        }
    }

    

    if (jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas) {

        const linhasCoberturaAux = jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas.split(fimLinha)
        let indexLinhasCoberturaAux = 0

        const linhasCobertura = []
        let indexLinhasCobertura = -1
        let adicionarLinhasCobertura = true

        while (indexLinhasCoberturaAux < linhasCoberturaAux.length) {

            if (linhasCoberturaAux[indexLinhasCoberturaAux].indexOf('PROPOSTA N.°') === -1) {

                if (adicionarLinhasCobertura) {

                    indexLinhasCobertura++
    
                    linhasCobertura.push('')
    
                    adicionarLinhasCobertura = false
                }

                linhasCobertura[indexLinhasCobertura] +=
                    (linhasCobertura[indexLinhasCobertura] ? espaco : '' ) + linhasCoberturaAux[indexLinhasCoberturaAux]

                if (linhasCoberturaAux[indexLinhasCoberturaAux].indexOf(',') !== -1) {
                    
                    adicionarLinhasCobertura = true

                }
            }

            indexLinhasCoberturaAux++
        }



        const coberturas = []

        let numeroCobertura
        let codigoCobertura
        let descricaoCobertura
        let dadosCobertura
        let valorCS
        let valorPremioLiquido
        let valorIof
        let valorPremio
        let classeAjusteRisco = ''
        let valorPremioExtra = ''
        let duracaoPremioExtra = ''
        let dataTerminoCobertura
        let valorRendaMensal = ''

        indexLinhasCobertura = 0

        while (indexLinhasCobertura < linhasCobertura.length) {

            dadosCobertura = linhasCobertura[indexLinhasCobertura].split(espaco)
            
            valorCS = trataValorTexto(dadosCobertura[dadosCobertura.length - 4])
            valorPremioLiquido = trataValorTexto(dadosCobertura[dadosCobertura.length - 3])
            valorIof = trataValorTexto(dadosCobertura[dadosCobertura.length - 2])
            valorPremio = trataValorTexto(dadosCobertura[dadosCobertura.length - 1])

            descricaoCobertura = ''

            indexLinhasCoberturaAux = 0

            while (indexLinhasCoberturaAux < dadosCobertura.length - 5) {
            
                descricaoCobertura += (descricaoCobertura ? espaco : '') + dadosCobertura[indexLinhasCoberturaAux]
            
                indexLinhasCoberturaAux++
            }

            if (descricaoCobertura.indexOf('VIDA TOTAL') !== -1) {

                dataTerminoCobertura = dataAnoMesDia(
                    ano(jsonRegistros.jsonRegistros[indexJsonRegistros].nascimentoSeguradoCliente) + 100/* - 1*/,
                    mes(jsonRegistros.jsonRegistros[indexJsonRegistros].dataAssinatura),
                    dia(jsonRegistros.jsonRegistros[indexJsonRegistros].dataAssinatura)
                )

            } else {

                dataTerminoCobertura = dataAnoMesDia(
                    ano(jsonRegistros.jsonRegistros[indexJsonRegistros].dataAssinatura) +
                        Number.parseInt(dadosCobertura[dadosCobertura.length - 5]),
                    mes(jsonRegistros.jsonRegistros[indexJsonRegistros].dataAssinatura),
                    dia(jsonRegistros.jsonRegistros[indexJsonRegistros].dataAssinatura)
                )
            } 

            const tipoCoberturaSeguroVida = identificaTipoCoberturaSeguroVida(descricaoCobertura, linhaIntegracao,
                jsonRegistros.jsonRegistros[indexJsonRegistros], nomeArquivo, erros)

            incluiCoberturas(coberturas, numeroCobertura, codigoCobertura, descricaoCobertura, tipoCoberturaSeguroVida, null, valorCS,
                valorPremioLiquido, valorIof, valorPremio, classeAjusteRisco, valorPremioExtra, duracaoPremioExtra,
                    dataTerminoCobertura, valorRendaMensal)

            indexLinhasCobertura += 1
        }

        jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas = coberturas

    }



    jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)
    


    return jsonRegistros.jsonRegistros
}



export const importaPropostaMetLifeNovoLayout = (PDFTxt, idUsuarioLogado, vars, equipeList, linhaIntegracao, seguradora,
    nomeArquivo, erros, variaveisGlobais) => {

    const jsonRegistros = jsonRegistrosInicializacao()

    jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

    const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

    PDFTxt = PDFTxt.replace(fimLinha + 'Empresário(a) / Administrador' + fimLinha + '(a)' + fimLinha,
        fimLinha + 'Empresário(a) / Administrador(a)' + fimLinha)

    PDFTxt = PDFTxt.replaceAll(fimLinha + 'Capital segurado' + fimLinha + '(R$)' + fimLinha + 'Prêmio' + fimLinha + 'Líquido (R$)' +
        fimLinha + 'IOF' + fimLinha + '(R$)' + fimLinha + 'Prêmio' + espaco + fimLinha + 'Bruto (R$)' + fimLinha, fimLinha)
    
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'Cobertura Prazo' + fimLinha + 'Capital segurado' + fimLinha + '(R$)' + fimLinha + 'Prêmio' + fimLinha + 'Líquido (R$)' +
        fimLinha + 'IOF' + fimLinha + '(R$)' + fimLinha + 'Prêmio' + espaco + fimLinha + 'Bruto (R$)Plano' + fimLinha, fimLinha)
    
    /*
    if (
            PDFTxt.indexOf(fimLinha + 'Doenças Graves e' + espaco) !== -1 &&
            PDFTxt.indexOf(fimLinha + 'Procedimentos' + fimLinha + 'Cirúrgicos' + fimLinha) !== -1
    ) {

        PDFTxt = PDFTxt.replace(fimLinha + 'Doenças Graves e' + espaco, 
            fimLinha + 'Doenças Graves e Procedimentos Cirúrgicos' + espaco)
        PDFTxt = PDFTxt.replace(fimLinha + 'Procedimentos' + fimLinha + 'Cirúrgicos' + fimLinha, fimLinha)
    }

    if (
            PDFTxt.indexOf(fimLinha + 'Doenças Graves e' + espaco) !== -1 &&
            PDFTxt.indexOf(fimLinha + 'Procedimentos' + fimLinha + 'Cirúrgicos Premium' + fimLinha) !== -1
    ) {

        PDFTxt = PDFTxt.replace(fimLinha + 'Doenças Graves e' + espaco, 
            fimLinha + 'Doenças Graves e Procedimentos Cirúrgicos' + espaco)
        PDFTxt = PDFTxt.replace(fimLinha + 'Procedimentos' + fimLinha + 'Cirúrgicos Premium' + fimLinha, fimLinha)
    }
    
    if (
            PDFTxt.indexOf(fimLinha + 'Diária por Internação' + espaco) !== -1 &&
            PDFTxt.indexOf(fimLinha + 'Hospitalar' + fimLinha) !== -1
    ) {

        PDFTxt = PDFTxt.replace(fimLinha + 'Diária por Internação' + espaco, 
            fimLinha + 'Diária por Internação Hospitalar' + espaco)
        PDFTxt = PDFTxt.replace(fimLinha + 'Hospitalar' + fimLinha, fimLinha)
    }
    */

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'CPF (preenchimento obrigatório)' + fimLinha, fimLinha, 
        HARDCODE.importacaoCpfSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'NIF* (para estrangeiros)' + fimLinha, fimLinha, 
        HARDCODE.importacaoNascimentoSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Endereço completo (rua, número e complemento)' + espaco + fimLinha,
        fimLinha, HARDCODE.importacaoEnderecoSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha, fimLinha,
        HARDCODE.importacaoProfissaoSegurado, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Renda mensal' + fimLinha, fimLinha,
        HARDCODE.importacaoRendaMensal, true, null, erros, nomeArquivo)

    obtemDadoPDFAnterior(PDFTxt, jsonRegistros, fimLinha + 'Sexo' + fimLinha, espaco,
        HARDCODE.importacaoSexoSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Bairro' + fimLinha, fimLinha,
        HARDCODE.importacaoBairroSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Cidade' + fimLinha, fimLinha,
        HARDCODE.importacaoCidadeSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'CEP' + fimLinha, fimLinha,
        HARDCODE.importacaoCepSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'UF' + fimLinha, fimLinha,
        HARDCODE.importacaoUfSeguradoCliente, true, null, erros, nomeArquivo)
            
    obtemDadoPDFAnterior(PDFTxt, jsonRegistros, fimLinha + 'Telefone celular (Cód. País + Cód.' + fimLinha + 'Cidade + Telefone):' +
        fimLinha, fimLinha, HARDCODE.importacaoCelularSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDFAnterior(PDFTxt, jsonRegistros, fimLinha + 'E-mail' + fimLinha, fimLinha,
        HARDCODE.importacaoEmailSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Proposta de Contratação de seguro de vida' + fimLinha, 'Nº' + fimLinha,
        HARDCODE.importacaoNumeroProposta, true, null, erros, nomeArquivo)
        
    obtemDadoPDFAnterior(PDFTxt, jsonRegistros, fimLinha + 'Nome do proponente (completo e sem abreviações)' + fimLinha, fimLinha,
        HARDCODE.importacaoNomeSeguradoCliente, true, null, erros, nomeArquivo)

    jsonRegistros.jsonRegistros[indexJsonRegistros].statusProposta = HARDCODE.idStatusPropostaPendente

    
    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Produto – Cobertura Básica do Seguro' + fimLinha + 'Nome Prazo' + fimLinha,
        fimLinha + 'Coberturas Adicionais do Seguro (exceto para os produtos MetLife Vida Empresarial Total e MetLife Vida' + fimLinha,
            HARDCODE.importacaoPropostaCoberturas, false, null, erros, nomeArquivo)
    
    if (!jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas) {

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Produto – Cobertura Básica do Seguro' + fimLinha + 'Nome Prazo' + fimLinha,
            fimLinha + 'Vida Total Singular - Ramo 1391 (Vida Individual) Proc. Susep Nº 15414.632170/2024-49' + fimLinha,
                HARDCODE.importacaoPropostaCoberturas, true, null, erros, nomeArquivo)
        
    }

    /*
    const coberturaBasica = jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas
    
    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Prêmio' + fimLinha + 'Bruto (R$)',
        fimLinha + 'Total' + espaco,
            HARDCODE.importacaoPropostaCoberturas, false, null, erros, nomeArquivo)

    jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas = coberturaBasica +
        (
            jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas
                ?
                    fimLinha + jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas
                :
                    ''
        )
    */

    if (PDFTxt.indexOf('MensalX') !== -1) {

        jsonRegistros.jsonRegistros[indexJsonRegistros].tipoPeriodicidadePagtoPremio = HARDCODE.idTipoPeriodicidadeMensal

    } else {

        jsonRegistros.jsonRegistros[indexJsonRegistros].tipoPeriodicidadePagtoPremio = HARDCODE.idTipoPeriodicidadeAnual
    }

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'token enviado por Email/SMS em' + espaco + fimLinha, espaco,
        HARDCODE.importacaoDataAssinatura, false, null, erros, nomeArquivo)
    
    if (!jsonRegistros.jsonRegistros[indexJsonRegistros].dataAssinatura) {

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Email/SMS em' + espaco, espaco,
            HARDCODE.importacaoDataAssinatura, false, null, erros, nomeArquivo)

        if (!jsonRegistros.jsonRegistros[indexJsonRegistros].dataAssinatura) {

            obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'um token enviado por Email/SMS' + espaco + fimLinha + 'em' +
                espaco, espaco, HARDCODE.importacaoDataAssinatura, false, null, erros, nomeArquivo)

            if (!jsonRegistros.jsonRegistros[indexJsonRegistros].dataAssinatura) {

                obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'enviado por Email/SMS em' + espaco + fimLinha, espaco,
                    HARDCODE.importacaoDataAssinatura, true, null, erros, nomeArquivo)
            }
        }
    }
    


    if (jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas) {

        const linhasCoberturaAux = jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas.split(fimLinha)
        let indexLinhasCoberturaAux = 0

        const linhasCobertura = []
        let indexLinhasCobertura = -1
        let adicionarLinhasCobertura = true

        while (indexLinhasCoberturaAux < linhasCoberturaAux.length) {

            if (
                    linhasCoberturaAux[indexLinhasCoberturaAux].indexOf('PROPOSTA N.°') === -1 &&
                    linhasCoberturaAux[indexLinhasCoberturaAux].substring(0, 6) !== 'TOTAL '
            ) {

                if (adicionarLinhasCobertura) {

                    indexLinhasCobertura++
    
                    linhasCobertura.push('')
    
                    adicionarLinhasCobertura = false
                }

                linhasCobertura[indexLinhasCobertura] +=
                    (linhasCobertura[indexLinhasCobertura] ? espaco : '' ) + linhasCoberturaAux[indexLinhasCoberturaAux].trim()

                if (linhasCoberturaAux[indexLinhasCoberturaAux].indexOf(',') !== -1) {
                    
                    adicionarLinhasCobertura = true

                }
            }

            indexLinhasCoberturaAux++
        }



        const coberturas = []

        let numeroCobertura
        let codigoCobertura
        let descricaoCobertura
        let dadosCobertura
        let valorCS
        let valorPremioLiquido
        let valorIof
        let valorPremio
        let classeAjusteRisco = ''
        let valorPremioExtra = ''
        let duracaoPremioExtra = ''
        let dataTerminoCobertura
        let valorRendaMensal = ''

        indexLinhasCobertura = 0

        while (indexLinhasCobertura < linhasCobertura.length) {

            dadosCobertura = linhasCobertura[indexLinhasCobertura].split(espaco)
            
            valorCS = trataValorTexto(dadosCobertura[dadosCobertura.length - 4])
            valorPremioLiquido = trataValorTexto(dadosCobertura[dadosCobertura.length - 3])
            valorIof = trataValorTexto(dadosCobertura[dadosCobertura.length - 2])
            valorPremio = trataValorTexto(dadosCobertura[dadosCobertura.length - 1])

            descricaoCobertura = ''

            indexLinhasCoberturaAux = 0

            while (indexLinhasCoberturaAux < dadosCobertura.length - 4/*5*/) {
            
                descricaoCobertura += (descricaoCobertura ? espaco : '') + dadosCobertura[indexLinhasCoberturaAux]
            
                indexLinhasCoberturaAux++
            }

            if (descricaoCobertura.indexOf('VIDA TOTAL') !== -1) {

                dataTerminoCobertura = dataAnoMesDia(
                    ano(jsonRegistros.jsonRegistros[indexJsonRegistros].nascimentoSeguradoCliente) + 100/* - 1*/,
                    mes(jsonRegistros.jsonRegistros[indexJsonRegistros].dataAssinatura),
                    dia(jsonRegistros.jsonRegistros[indexJsonRegistros].dataAssinatura)
                )

            } else {

                dataTerminoCobertura = dataAnoMesDia(
                    ano(jsonRegistros.jsonRegistros[indexJsonRegistros].dataAssinatura) +
                        Number.parseInt(dadosCobertura[dadosCobertura.length - 5]),
                    mes(jsonRegistros.jsonRegistros[indexJsonRegistros].dataAssinatura),
                    dia(jsonRegistros.jsonRegistros[indexJsonRegistros].dataAssinatura)
                )
            } 

            const tipoCoberturaSeguroVida = identificaTipoCoberturaSeguroVida(descricaoCobertura, linhaIntegracao,
                jsonRegistros.jsonRegistros[indexJsonRegistros], nomeArquivo, erros)

            incluiCoberturas(coberturas, numeroCobertura, codigoCobertura, descricaoCobertura, tipoCoberturaSeguroVida, null, valorCS,
                valorPremioLiquido, valorIof, valorPremio, classeAjusteRisco, valorPremioExtra, duracaoPremioExtra,
                    dataTerminoCobertura, valorRendaMensal)

            indexLinhasCobertura += 1
        }

        jsonRegistros.jsonRegistros[indexJsonRegistros].propostaCoberturas = coberturas

    }



    jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)
    


    return jsonRegistros.jsonRegistros
}



export const importaListaPropostasImplantacaoMetLife = (XLSX, idUsuarioLogado, vars, equipeList, linhaIntegracao, seguradora,
    nomeArquivo, erros, variaveisGlobais) => {

    let jsonRegistros = jsonRegistrosInicializacao()

    let linha = linhaIntegracao.cabecalho + 1

    const timeSeguradoraAux = timeSeguradora(idUsuarioLogado, equipeList, seguradora)

    while (linha < XLSX.length) {

        if (XLSX[linha][2] && XLSX[linha][1] === 'Vida') {

            jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

            const codigoAgente = trataTexto(XLSX[linha][8])

            const usuarioClienteSelecionado = idAgenteTimeSeguradora(timeSeguradoraAux, codigoAgente)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 2, HARDCODE.importacaoNumeroProposta, true, null, erros, nomeArquivo)

            const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

            jsonRegistros.jsonRegistros[indexJsonRegistros].numeroProposta =
                '' + Number.parseInt(jsonRegistros.jsonRegistros[indexJsonRegistros].numeroProposta)


            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 5, HARDCODE.importacaoNomeSeguradoCliente, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 6, HARDCODE.importacaoCpfSeguradoCliente, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 45/*33*//*32*/, HARDCODE.importacaoNascimentoSeguradoCliente, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 48/*36*//*35*/, HARDCODE.importacaoProfissaoSegurado, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 44/*32*//*31*/, HARDCODE.importacaoCidadeSeguradoCliente, true, null, erros, nomeArquivo)
            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 41/*29*//*28*/, HARDCODE.importacaoCelularSeguradoCliente, false, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 42/*30*//*29*/, HARDCODE.importacaoEmailSeguradoCliente, false, null, erros, nomeArquivo)
            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 49/*37*//*36*/, HARDCODE.importacaoRendaMensal, true, null, erros, nomeArquivo)



            obtemDadoXLSX(XLSX, jsonRegistros, linha, 3, HARDCODE.importacaoStatusProposta, true,
                linhaIntegracao.statusProposta, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 4, HARDCODE.importacaoDataAssinatura, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 7, HARDCODE.importacaoDataUltimaAlteracao, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 13/*12*/, HARDCODE.importacaoValorPremioAnualizado, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 17/*16*/, HARDCODE.importacaoTipoPeriodicidadePagtoPremio, true, null, erros, nomeArquivo)

            jsonRegistros.jsonRegistros[indexJsonRegistros].valorPremioAnualizado = 
                calculaValorAnual(jsonRegistros.jsonRegistros[indexJsonRegistros].valorPremioAnualizado,
                    jsonRegistros.jsonRegistros[indexJsonRegistros].tipoPeriodicidadePagtoPremio) 
            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 46/*34*//*33*/, HARDCODE.importacaoTipoFormaPagtoPremio, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 18/*17*/, HARDCODE.importacaoObservacao, false, null, erros, nomeArquivo)



            if (usuarioClienteSelecionado) {

                jsonRegistros.jsonRegistros[indexJsonRegistros].usuarioClienteSelecionado = usuarioClienteSelecionado
     
            } else {

                erros.push(MESSAGE().agenteNaoEncontradoProposta
                    .replace("$numeroProposta$", jsonRegistros.jsonRegistros[indexJsonRegistros].numeroProposta)
                        .replace("$codigoAgente$", codigoAgente)
                )
            }

            jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)
        }
       
        linha++
    }

    return jsonRegistros.jsonRegistros
}



export const importaListaPropostasMetLife = (XLSX, idUsuarioLogado, vars, equipeList, linhaIntegracao, seguradora,
    nomeArquivo, erros, variaveisGlobais) => {

    let jsonRegistros = jsonRegistrosInicializacao()

    let linha = linhaIntegracao.cabecalho + 1

    const timeSeguradoraAux = timeSeguradora(idUsuarioLogado, equipeList, seguradora)

    while (linha < XLSX.length) {

        if (XLSX[linha][2]) {

            jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

            const codigoAgente = trataTexto(XLSX[linha][8])

            const usuarioClienteSelecionado = idAgenteTimeSeguradora(timeSeguradoraAux, codigoAgente)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 2, HARDCODE.importacaoNumeroProposta, true, null, erros, nomeArquivo)

            const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

            jsonRegistros.jsonRegistros[indexJsonRegistros].numeroProposta =
                '' + Number.parseInt(jsonRegistros.jsonRegistros[indexJsonRegistros].numeroProposta)

           

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 3, HARDCODE.importacaoStatusProposta, true,
                linhaIntegracao.statusProposta, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 4, HARDCODE.importacaoDataAssinatura, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 7, HARDCODE.importacaoDataUltimaAlteracao, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 12, HARDCODE.importacaoValorPremioAnualizado, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 16, HARDCODE.importacaoTipoPeriodicidadePagtoPremio, true, null, erros, nomeArquivo)

            jsonRegistros.jsonRegistros[indexJsonRegistros].valorPremioAnualizado = 
                calculaValorAnual(jsonRegistros.jsonRegistros[indexJsonRegistros].valorPremioAnualizado,
                    jsonRegistros.jsonRegistros[indexJsonRegistros].tipoPeriodicidadePagtoPremio) 
            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 33, HARDCODE.importacaoTipoFormaPagtoPremio, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 17, HARDCODE.importacaoObservacao, false, null, erros, nomeArquivo)



            if (usuarioClienteSelecionado) {

                jsonRegistros.jsonRegistros[indexJsonRegistros].usuarioClienteSelecionado = usuarioClienteSelecionado
     
            } else {

                erros.push(MESSAGE().agenteNaoEncontradoProposta
                    .replace("$numeroProposta$", jsonRegistros.jsonRegistros[indexJsonRegistros].numeroProposta)
                        .replace("$codigoAgente$", codigoAgente)
                )
            }

            jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)
        }
       
        linha++
    }

    return jsonRegistros.jsonRegistros
}



export const importaApoliceMetLife = (PDFTxt, idUsuarioLogado, vars, equipeList, linhaIntegracao, seguradora,
    nomeArquivo, erros, variaveisGlobais) => {

    const jsonRegistros = jsonRegistrosInicializacao()

    jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

    PDFTxt = PDFTxt.replace('Versão 1' + fimLinha, '') // suposição
    PDFTxt = PDFTxt.replace('Versão 2' + fimLinha, '') // suposição
    PDFTxt = PDFTxt.replace('Versão 3' + fimLinha, '')
    PDFTxt = PDFTxt.replace('Versão 4' + fimLinha, '')
    PDFTxt = PDFTxt.replace('Versão 5' + fimLinha, '') // suposição
    PDFTxt = PDFTxt.replace('Versão 6' + fimLinha, '') // suposição
    PDFTxt = PDFTxt.replace('Versão 7' + fimLinha, '') // suposição
    PDFTxt = PDFTxt.replace('Versão 8' + fimLinha, '') // suposição
    PDFTxt = PDFTxt.replace('Versão 9' + fimLinha, '')
    PDFTxt = PDFTxt.replace('Versão 10' + fimLinha, '')
    PDFTxt = PDFTxt.replace('Versão 11' + fimLinha, '') // suposição
    PDFTxt = PDFTxt.replace('Versão 12' + fimLinha, '') // suposição
    PDFTxt = PDFTxt.replace('Versão 13' + fimLinha, '') // suposição
    PDFTxt = PDFTxt.replace('Versão 14' + fimLinha, '') // suposição
    PDFTxt = PDFTxt.replace('Versão 15' + fimLinha, '') // suposição
    PDFTxt = PDFTxt.replace('Versão 16' + fimLinha, '') // suposição
    PDFTxt = PDFTxt.replace('Versão 17' + fimLinha, '') // suposição
    PDFTxt = PDFTxt.replace('Versão 18' + fimLinha, '') // suposição
    PDFTxt = PDFTxt.replace('Versão 19' + fimLinha, '') // suposição
    PDFTxt = PDFTxt.replace('Versão 20' + fimLinha, '') // suposição

    PDFTxt = PDFTxt.replace('peterlongo' + fimLinha, 'PETERLONGO' + fimLinha)
    PDFTxt = PDFTxt.replace('Fatima' + fimLinha, 'FATIMA' + fimLinha)
    PDFTxt = PDFTxt.replace('AndradasCentro' + fimLinha, 'AndradasCENTRO' + fimLinha)
    PDFTxt = PDFTxt.replace('Retiro das Pedras' + fimLinha, 'RETIRO DAS PEDRAS' + fimLinha)
    PDFTxt = PDFTxt.replace('Novo Paraiso' + fimLinha, 'NOVO PARAISO' + fimLinha)

    PDFTxt = PDFTxt.replace(fimLinha + 'Cirúrgicos' + fimLinha + '84-Doença Grave ou Terminal' + espaco,
        fimLinha + 'Cirúrgicos' + espaco + '84-Doença Grave ou Terminal' + espaco)
    PDFTxt = PDFTxt.replace('Morte 91 - Vida Individual', 'Morte 91-Vida Individual')
    PDFTxt = PDFTxt.replace('Morte Acidental 81 - Acidentes Pessoais', 'Morte Acidental 81-Acidentes Pessoais')
    PDFTxt = PDFTxt.replace('Invalidez Total Ou Parcial Por ' + fimLinha + 'Acidente 81 - Acidentes Pessoais',
        'Invalidez Total ou Parcial por Acidente 81-Acidentes Pessoais')
    PDFTxt = PDFTxt.replaceAll('Invalidez Total Ou Parcial Por ' + fimLinha + 'Acidente' + fimLinha,
        'Invalidez Total ou Parcial por Acidente ')
    PDFTxt = PDFTxt.replaceAll('81 - Acidentes Pessoais ', '81-Acidentes Pessoais ')
    PDFTxt = PDFTxt.replace('Doenças Graves E Procedimentos ' + fimLinha + 'Cirúrgicos Premium 84 - Doença Grave ou Terminal',
        '84-Doença Grave ou Terminal ')
    PDFTxt = PDFTxt.replaceAll('Doenças Graves E Procedimentos ' + fimLinha + 'Cirúrgicos Premium' + fimLinha,
        'Doenças Graves e Procedimentos Cirúrgicos Premium ')
    PDFTxt = PDFTxt.replaceAll('Doenças Graves e Procedimentos ' + fimLinha + 'Cirúrgicos Premium' + fimLinha,
        'Doenças Graves e Procedimentos Cirúrgicos Premium ')
    PDFTxt = PDFTxt.replaceAll('84 - Doença Grave ou Terminal ', '84-Doença Grave ou Terminal ')
    PDFTxt = PDFTxt.replace('Diária De Internação Hospitalar 90 - Eventos Aleatórios',
        'Diária de Internação Hospitalar 90-Eventos Aleatórios')
    PDFTxt = PDFTxt.replace('Funeral Individual 29 - Funeral ',
        'Funeral Individual 29-Funeral ')
    PDFTxt = PDFTxt.replace(fimLinha + 'Invalidez Total Ou Parcial Por ' + fimLinha + 'Acidente ',
        fimLinha + 'Invalidez Total ou Parcial por Acidente ')
    PDFTxt = PDFTxt.replaceAll(fimLinha + 'Diária De Internação Hospitalar ', fimLinha + 'Diária de Internação Hospitalar ')
    PDFTxt = PDFTxt.replaceAll('Morte Com Capital Segurado ', 'Com Capital Segurado ')
    PDFTxt = PDFTxt.replace('Decrescente A Cada Ano 91 - Vida Individual', 'Decrescente A Cada Ano 91-Vida Individual')
    PDFTxt = PDFTxt.replace('Morte  ', 'Morte 91-Vida Individual')
    PDFTxt = PDFTxt.replaceAll(' 24:00', '')
    PDFTxt = PDFTxt.replaceAll('Morte Acidental  ', 'Morte Acidental 81-Acidentes Pessoais ')
    PDFTxt = PDFTxt.replaceAll('Invalidez Total ou Parcial por Acidente  ', 'Invalidez Total ou Parcial por Acidente 81-Acidentes Pessoais ')
    PDFTxt = PDFTxt.replaceAll('Diária de Internação Hospitalar  ', 'Diária de Internação Hospitalar 90-Eventos Aleatórios ')
    PDFTxt = PDFTxt.replaceAll('Doenças Graves Mais Proteção  ', 'Doenças Graves Mais Proteção 84-Doença Grave ou Terminal ')
    PDFTxt = PDFTxt.replaceAll('Doenças Graves e Procedimentos Cirúrgicos Premium  ', 'Doenças Graves e Procedimentos Cirúrgicos Premium 84-Doença Grave ou Terminal ')
    PDFTxt = PDFTxt.replaceAll('Funeral Individual  ', 'Funeral Individual 29-Funeral ')
    PDFTxt = PDFTxt.replaceAll('Funeral Cônjuge  ', 'Funeral Cônjuge 29-Funeral ')
    PDFTxt = PDFTxt.replaceAll('Fratura Óssea  ', 'Fratura Óssea 90-Eventos Aleatórios ')
    PDFTxt = PDFTxt.replaceAll('Morte com Capital Segurado ' + fimLinha + 'Decrescente 20 anos' + fimLinha,
        'Morte com Capital Segurado Decrescente 20 anos ')
    //console.log(PDFTxt)
    
    
    //PDFTxt = PDFTxt.replace(fimLinha + 'Fator ' + fimLinha + 'aditivo' + fimLinha + 'Fator ' + fimLinha + 'multiplicativo' + fimLinha,
    //    fimLinha + 'As Coberturas contratadas terão seu início e término de vigência às 24 horas das datas acima indicadas. ' + fimLinha)
    
    const linhasPDFTxt = PDFTxt.split(fimLinha)
    //console.log(linhasPDFTxt)

    let indexAux



    if (linhasPDFTxt[0] === 'Apólice individual do seguro' || linhasPDFTxt[0] === 'Renovação - Apólice individual do seguro') {

        if (
                linhasPDFTxt[3] === 'Cobertura(s) e capital(is) segurado(s) individual(is)' ||
                linhasPDFTxt[4] === 'Cobertura Prêmio líquido (R$) IOF (R$)' ||
                linhasPDFTxt[3] === 'Prêmio(s) por cobertura(s)'
        ) {

            const indexInicialDados = indexTexto(linhasPDFTxt, 'Nome do segurado Data de nascimento CPF')

            const propostaApolice = linhasPDFTxt[indexInicialDados + 6].replace('Nº da proposta: ', '').replace('Nº da apólice: ', '').split(espaco)
            
            if (linhasPDFTxt[indexInicialDados + 6].indexOf('Nº da proposta: Nº da apólice:') === -1) {

                obtemDadoPDFAvulso (jsonRegistros, propostaApolice[0], HARDCODE.importacaoNumeroProposta, true, null, erros, nomeArquivo)
                obtemDadoPDFAvulso (jsonRegistros, propostaApolice[1], HARDCODE.importacaoNumeroApolice, true, null, erros, nomeArquivo)

            } else {

                obtemDadoPDFAvulso (jsonRegistros, propostaApolice[0], HARDCODE.importacaoNumeroApolice, true, null, erros, nomeArquivo)
            }
            
            const dataEmisssao = linhasPDFTxt[indexInicialDados + 8].split(espaco)
            obtemDadoPDFAvulso (jsonRegistros, dataEmisssao[dataEmisssao.length - 1], HARDCODE.importacaoDataEmissao, true, null, erros, nomeArquivo)

            const periodicidadePagtoPremio = linhasPDFTxt[indexInicialDados + 7].split(espaco)
            obtemDadoPDFAvulso (jsonRegistros, periodicidadePagtoPremio[periodicidadePagtoPremio.length - 1], HARDCODE.importacaoTipoPeriodicidadePagtoPremio, true,
                null, erros, nomeArquivo)

            const bairroCepCidadeUF = linhasPDFTxt[indexInicialDados + 5].split(espaco)

            const posCep = indexCampoComecaTerminaComNumero(bairroCepCidadeUF)

            obtemDadoPDFAvulso (jsonRegistros, bairroCepCidadeUF[posCep], HARDCODE.importacaoCepSeguradoCliente, true,
                null, erros, nomeArquivo)

            obtemDadoPDFAvulso (jsonRegistros, bairroCepCidadeUF[bairroCepCidadeUF.length - 1],
                HARDCODE.importacaoUfSeguradoCliente, true, null, erros, nomeArquivo)

            obtemDadoPDFAvulso (jsonRegistros, obtemTextoArray(bairroCepCidadeUF, posCep + 1, bairroCepCidadeUF.length - 2),
                HARDCODE.importacaoCidadeSeguradoCliente, true, null, erros, nomeArquivo)

            obtemDadoPDFAvulso (jsonRegistros, obtemTextoArray(bairroCepCidadeUF, 0, posCep - 1),
                HARDCODE.importacaoBairroSeguradoCliente, true, null, erros, nomeArquivo)

            //obtemDadoPDFAvulso (jsonRegistros, linhasPDFTxt[20].substring(0, posRua),
            //    HARDCODE.importacaoNumeroEnderecoSeguradoCliente, false, null, erros, nomeArquivo)

            obtemDadoPDFAvulso (jsonRegistros, linhasPDFTxt[indexInicialDados + 3],
                HARDCODE.importacaoEnderecoSeguradoCliente, true, null, erros, nomeArquivo)



            const nomeNascimentoCpf = linhasPDFTxt[indexInicialDados + 1].split(espaco)

            obtemDadoPDFAvulso (jsonRegistros, nomeNascimentoCpf[nomeNascimentoCpf.length - 1],
                HARDCODE.importacaoCpfSeguradoCliente, true, null, erros, nomeArquivo)

            obtemDadoPDFAvulso (jsonRegistros, nomeNascimentoCpf[nomeNascimentoCpf.length - 2],
                HARDCODE.importacaoNascimentoSeguradoCliente, true, null, erros, nomeArquivo)

            obtemDadoPDFAvulso (jsonRegistros, obtemTextoArray(nomeNascimentoCpf, 0, nomeNascimentoCpf.length - 3),
                HARDCODE.importacaoNomeSeguradoCliente, true, null, erros, nomeArquivo)
  
        } else {

            let ajuste1 = 0
            let ajuste2 = 0

            if (linhasPDFTxt[3].indexOf('/') !== -1) {
                
                ajuste1 = 1

                if (linhasPDFTxt[33].indexOf('/') !== -1) {
                    
                    ajuste2 = 12
                }
            }

            obtemDadoPDFAvulso (jsonRegistros, linhasPDFTxt[3 + ajuste1], HARDCODE.importacaoNumeroProposta, true, null, erros, nomeArquivo)

            obtemDadoPDFAvulso (jsonRegistros, linhasPDFTxt[5 + ajuste1], HARDCODE.importacaoDataEmissao, true, null, erros, nomeArquivo)

            obtemDadoPDFAvulso (jsonRegistros, linhasPDFTxt[6 + ajuste1], HARDCODE.importacaoTipoPeriodicidadePagtoPremio, true,
                null, erros, nomeArquivo)

            obtemDadoPDFAvulso (jsonRegistros, linhasPDFTxt[7 + ajuste1], HARDCODE.importacaoNumeroApolice, true, null, erros, nomeArquivo)
            


            const cepUFCidadeBairro = linhasPDFTxt[19 + ajuste2].split(espaco)

            obtemDadoPDFAvulso (jsonRegistros, cepUFCidadeBairro[0], HARDCODE.importacaoCepSeguradoCliente, true,
                null, erros, nomeArquivo)

            obtemDadoPDFAvulso (jsonRegistros, cepUFCidadeBairro[1].substring(0, 2), HARDCODE.importacaoUfSeguradoCliente, true,
                null, erros, nomeArquivo)

                

            cepUFCidadeBairro[1] = cepUFCidadeBairro[1].substring(2)

            let indexCepUFCidadeBairro = 1

            let cidade = ''

            while (
                cepUFCidadeBairro[indexCepUFCidadeBairro].substring(cepUFCidadeBairro[indexCepUFCidadeBairro].length - 2) !==
                cepUFCidadeBairro[indexCepUFCidadeBairro].substring(cepUFCidadeBairro[indexCepUFCidadeBairro].length - 2)
                    .toUpperCase()
            ) {

                cidade += (cidade ? espaco : '') + cepUFCidadeBairro[indexCepUFCidadeBairro]
                
                indexCepUFCidadeBairro++
            }

            let indexBairro = 1

            while (
                cepUFCidadeBairro[indexCepUFCidadeBairro].substring(indexBairro, indexBairro + 1) !==
                cepUFCidadeBairro[indexCepUFCidadeBairro].substring(indexBairro, indexBairro + 1).toUpperCase()
            ) {

                indexBairro++
            }

            cidade += (cidade ? espaco : '') + cepUFCidadeBairro[indexCepUFCidadeBairro].substring(0, indexBairro)

            obtemDadoPDFAvulso (jsonRegistros, cidade, HARDCODE.importacaoCidadeSeguradoCliente, true,
                null, erros, nomeArquivo)



            let bairro = cepUFCidadeBairro[indexCepUFCidadeBairro].substring(indexBairro)

            indexCepUFCidadeBairro++

            while (indexCepUFCidadeBairro < cepUFCidadeBairro.length) {

                bairro += (bairro ? espaco : '') + cepUFCidadeBairro[indexCepUFCidadeBairro]
                
                indexCepUFCidadeBairro++
            }

            obtemDadoPDFAvulso (jsonRegistros, bairro, HARDCODE.importacaoBairroSeguradoCliente, true,
                null, erros, nomeArquivo)



            let posRua = linhasPDFTxt[20 + ajuste2].indexOf('RUA' + espaco)

            if (posRua === -1) {

                posRua = linhasPDFTxt[20 + ajuste2].indexOf('Rua' + espaco)
            }

            if (posRua !== -1) {

                //obtemDadoPDFAvulso (jsonRegistros, linhasPDFTxt[20].substring(0, posRua),
                //    HARDCODE.importacaoNumeroEnderecoSeguradoCliente, false, null, erros, nomeArquivo)

                obtemDadoPDFAvulso (jsonRegistros, linhasPDFTxt[20 + ajuste2].substring(posRua),
                    HARDCODE.importacaoEnderecoSeguradoCliente, true, null, erros, nomeArquivo)

            } else {

                posRua = linhasPDFTxt[20 + ajuste2].length - 1

                while (
                        isNaN(linhasPDFTxt[20 + ajuste2].substring(posRua, posRua + 1)) ||
                        linhasPDFTxt[20 + ajuste2].substring(posRua, posRua + 1) === espaco
                ) {
                    
                    posRua--
                }

                //obtemDadoPDFAvulso (jsonRegistros, linhasPDFTxt[20].substring(0, posRua),
                //    HARDCODE.importacaoNumeroEnderecoSeguradoCliente, false, null, erros, nomeArquivo)

                obtemDadoPDFAvulso (jsonRegistros, linhasPDFTxt[20 + ajuste2].substring(posRua),
                    HARDCODE.importacaoEnderecoSeguradoCliente, true, null, erros, nomeArquivo)
            }



            const posBarra = linhasPDFTxt[21 + ajuste2].indexOf(barraData)

            obtemDadoPDFAvulso (jsonRegistros, linhasPDFTxt[21 + ajuste2].substring(0, posBarra -2), HARDCODE.importacaoCpfSeguradoCliente,
                true, null, erros, nomeArquivo)

            obtemDadoPDFAvulso (jsonRegistros, linhasPDFTxt[21 + ajuste2].substring(posBarra -2, posBarra + 8),
                HARDCODE.importacaoNascimentoSeguradoCliente, true, null, erros, nomeArquivo)

            obtemDadoPDFAvulso (jsonRegistros, linhasPDFTxt[21 + ajuste2].substring(posBarra + 8), HARDCODE.importacaoNomeSeguradoCliente,
                true, null, erros, nomeArquivo)
        }

        obtemDadoPDFAvulso (jsonRegistros, HARDCODE.idStatusApoliceAtiva, HARDCODE.importacaoStatusApolice, true, null, erros, nomeArquivo)



        const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

        let achou

        let indexIntegracao

        const coberturas = []
    
        let numeroCobertura
        let codigoCobertura
        let descricaoCobertura
        let tipoCoberturaSeguroVida
        let statusCobertura = HARDCODE.idStatusCoberturaAtivaPagandoPremio
        let valorCS
        let valorPremioLiquido
        let valorIof
        let valorPremio
        let classeAjusteRisco
        let valorPremioExtra
        let duracaoPremioExtra
        let dataTerminoCobertura
        let valorRendaMensal

        indexAux = indexPDFAvulso(linhasPDFTxt, 'Cobertura(s) e capital(is) segurado(s) individual(is)', 0) + 1

        while (
            linhasPDFTxt[indexAux] !==
                'As Coberturas contratadas terão seu início e término de vigência às 24 horas das datas acima indicadas.Os Capitais de ' &&
            linhasPDFTxt[indexAux] !==
                'A Cobertura contratada terá seu início e término de vigência às 24 horas da data acima indicada.Os Capitais de ' &&
            linhasPDFTxt[indexAux] !==
                'A Cobertura contratada terá seu início e término de vigência às 24 horas da data acima indicada. ' &&
            linhasPDFTxt[indexAux] !==
                'As Coberturas contratadas terão seu início e término de vigência às 24 horas das datas acima indicadas. ' &&
            linhasPDFTxt[indexAux] !==
                'As Coberturas contratadas terão seu início e término de vigência às 24 horas das datas acima indicadas. Os Capitais de '
        ) {

            achou = false

            indexIntegracao = 0

            while (indexIntegracao < linhaIntegracao.cobertura1.length) {

                const linhaCobertura = linhaIntegracao.cobertura1[indexIntegracao]

                if (!achou) {

                    if (linhasPDFTxt[indexAux].substring(0, linhaCobertura.chave.length) === linhaCobertura.chave) {

                        descricaoCobertura = linhaCobertura.descricaoCobertura

                        if (!descricaoCobertura) {

                            descricaoCobertura =
                                trataTexto(linhasPDFTxt[indexAux - 2] + linhasPDFTxt[indexAux - 1] + ' (' + linhaCobertura.chave + ')')
                        }

                        valorCS =
                            trataValorTexto(
                                linhasPDFTxt[indexAux].substring(
                                    linhaCobertura.chave.length,
                                    linhasPDFTxt[indexAux].indexOf(espaco, linhaCobertura.chave.length + 2)
                                )
                            )

                        tipoCoberturaSeguroVida = linhaCobertura.tipoCoberturaSeguroVida

                        if (linhasPDFTxt[indexAux].substring(linhasPDFTxt[indexAux].length - 9) === 'Vitalício') {

                            dataTerminoCobertura =
                                dataAnoMesDia(
                                    ano(jsonRegistros.jsonRegistros[indexJsonRegistros].nascimentoSeguradoCliente) + 100/* - 1*/,
                                    mes(jsonRegistros.jsonRegistros[indexJsonRegistros].dataEmissao),
                                    dia(jsonRegistros.jsonRegistros[indexJsonRegistros].dataEmissao)
                                )

                        } else {

                            if (
                                    linhasPDFTxt[3] === 'Cobertura(s) e capital(is) segurado(s) individual(is)' ||
                                    linhasPDFTxt[4] === 'Cobertura Prêmio líquido (R$) IOF (R$)' ||
                                    linhasPDFTxt[3] === 'Prêmio(s) por cobertura(s)'
                            ) {

                                dataTerminoCobertura = linhasPDFTxt[indexAux].split(espaco)
                                dataTerminoCobertura = trataData(dataTerminoCobertura[dataTerminoCobertura.length - 3])

                            } else {

                                dataTerminoCobertura = trataData(linhasPDFTxt[indexAux].substring(linhasPDFTxt[indexAux].length - 10))
                            }

                            if (tipoCoberturaSeguroVida === HARDCODE.idTipoCoberturaSeguroVidaVidaInteira) {

                                tipoCoberturaSeguroVida = HARDCODE.idTipoCoberturaSeguroVidaTemporario
                            }
                        }

                        incluiCoberturas(coberturas, numeroCobertura, codigoCobertura, descricaoCobertura,
                            tipoCoberturaSeguroVida, statusCobertura, valorCS, valorPremioLiquido, valorIof,
                                valorPremio, classeAjusteRisco, valorPremioExtra, duracaoPremioExtra, dataTerminoCobertura,
                                    valorRendaMensal)
                            
                        coberturas[coberturas.length - 1].id = linhaCobertura.id

                        achou = true
                    }
                }

                indexIntegracao++
            }
            
            jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas = coberturas

            indexAux++
        }
        //console.log(coberturas)

        indexAux = indexPDFAvulso(linhasPDFTxt, 'Prêmio(s) por cobertura(s)', indexAux) + 1

        let indexCobertura = 0

        while (linhasPDFTxt[indexAux] !== 'Prêmio de referência do mês de emissão desta apólice.') {

            achou = false

            indexIntegracao = 0

            while (indexIntegracao < linhaIntegracao.premio1.length) {

                const linhaPremio = linhaIntegracao.premio1[indexIntegracao]

                if (!achou) {

                    if (linhasPDFTxt[indexAux].substring(0, linhaPremio.chave.length) === linhaPremio.chave) {

                        let linha

                        const linhaPremioLinha =
                            linhasPDFTxt[3] === 'Cobertura(s) e capital(is) segurado(s) individual(is)' ||
                            linhasPDFTxt[4] === 'Cobertura Prêmio líquido (R$) IOF (R$)' ||
                            linhasPDFTxt[3] === 'Prêmio(s) por cobertura(s)'
                                ?
                                    linhaPremio.linha2
                                :
                                    linhaPremio.linha

                        if (linhaPremioLinha === 0) {

                            linha = linhasPDFTxt[indexAux].substring(linhaPremio.chave.length + 1)

                        } else {

                            linha = linhasPDFTxt[indexAux + linhaPremioLinha]
                        }

                        linha = linha.split(espaco)

                        //const indexCobertura = pesquisaIndexList(coberturas, linhaPremio.id)

                        if (
                                linhasPDFTxt[3] === 'Cobertura(s) e capital(is) segurado(s) individual(is)' ||
                                linhasPDFTxt[4] === 'Cobertura Prêmio líquido (R$) IOF (R$)' ||
                                linhasPDFTxt[3] === 'Prêmio(s) por cobertura(s)'
                        ) {
                            
                            coberturas[indexCobertura].valorPremioLiquido = trataValorTexto(linha[0])
                            coberturas[indexCobertura].valorIof = trataValorTexto(linha[1])
                            coberturas[indexCobertura].valorPremio = trataValorTexto(linha[2])

                        } else {

                            coberturas[indexCobertura].valorPremioLiquido = trataValorTexto(linha[3])
                            coberturas[indexCobertura].valorIof = trataValorTexto(linha[2])
                            coberturas[indexCobertura].valorPremio = trataValorTexto(linha[5])
                        }

                        achou = true

                        indexCobertura++
                    }
                }

                indexIntegracao++
            }
            
            jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas = coberturas

            indexAux++
        }

    } else {

        obtemDadoPDFAvulso (jsonRegistros, linhasPDFTxt[10].substring(0, linhasPDFTxt[10].indexOf(espaco)),
            HARDCODE.importacaoNumeroProposta, true, null, erros, nomeArquivo)

        obtemDadoPDFAvulso (jsonRegistros, linhasPDFTxt[12].substring(linhasPDFTxt[12].indexOf(barraData) - 2),
            HARDCODE.importacaoDataEmissao, true, null, erros, nomeArquivo)

        obtemDadoPDFAvulso (jsonRegistros, linhasPDFTxt[11].substring(linhasPDFTxt[11].indexOf(espaco) + 1),
            HARDCODE.importacaoTipoPeriodicidadePagtoPremio, true, null, erros, nomeArquivo)

        obtemDadoPDFAvulso (jsonRegistros, linhasPDFTxt[10].substring(linhasPDFTxt[10].indexOf(espaco) + 1),
            HARDCODE.importacaoNumeroApolice, true, null, erros, nomeArquivo)

        obtemDadoPDFAvulso (jsonRegistros, linhasPDFTxt[16].substring(linhasPDFTxt[16].indexOf(espaco) + 1),
            HARDCODE.importacaoCpfSeguradoCliente, true, null, erros, nomeArquivo)

        obtemDadoPDFAvulso (jsonRegistros, linhasPDFTxt[16].substring(0, linhasPDFTxt[16].indexOf(espaco)),
            HARDCODE.importacaoNascimentoSeguradoCliente, true, null, erros, nomeArquivo)

        obtemDadoPDFAvulso (jsonRegistros, linhasPDFTxt[14], HARDCODE.importacaoNomeSeguradoCliente, true, null, erros, nomeArquivo)

        obtemDadoPDFAvulso (jsonRegistros, HARDCODE.idStatusApoliceAtiva, HARDCODE.importacaoStatusApolice, true, null, erros, nomeArquivo)

        indexAux = indexPDFAvulso(linhasPDFTxt, 'Telefone residencial', 0)

        if (linhasPDFTxt[indexAux + 2].substring(0, 1) === '+') {

            obtemDadoPDFAvulso (jsonRegistros, linhasPDFTxt[indexAux + 2], HARDCODE.importacaoTelefoneSegurado, true, null, erros, nomeArquivo)
        }

        indexAux = indexPDFAvulso(linhasPDFTxt, 'Telefone comercial', indexAux)

        if (linhasPDFTxt[indexAux + 2].substring(0, 1) === '+') {

            obtemDadoPDFAvulso (jsonRegistros, linhasPDFTxt[indexAux + 2], HARDCODE.importacaoTelefoneComercialSegurado,
                true, null, erros, nomeArquivo)
        }

        indexAux = indexPDFAvulso(linhasPDFTxt, 'Telefone celular', indexAux)

        if (linhasPDFTxt[indexAux + 2].substring(0, 1) === '+') {

            obtemDadoPDFAvulso (jsonRegistros, linhasPDFTxt[indexAux + 2],
                HARDCODE.importacaoCelularSeguradoCliente, true, null, erros, nomeArquivo)
        }

        indexAux = indexPDFAvulso(linhasPDFTxt,
            'Os seus dados identificados acima estão cadastrados em nosso sistema e serão utilizados como meio de contato,', indexAux)

        if (linhasPDFTxt[indexAux - 1].substring(0, 6) === 'Email:') {

            obtemDadoPDFAvulso (jsonRegistros, linhasPDFTxt[indexAux - 1].substring(7), HARDCODE.importacaoEmailSeguradoCliente,
                true, null, erros, nomeArquivo)
        }
        
        const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

        let achou

        let indexIntegracao

        const coberturas = []
    
        let numeroCobertura
        let codigoCobertura
        let descricaoCobertura
        let statusCobertura = HARDCODE.idStatusCoberturaAtivaPagandoPremio
        let valorCS
        let valorPremioLiquido
        let valorIof
        let valorPremio
        let classeAjusteRisco
        let valorPremioExtra
        let duracaoPremioExtra
        let dataTerminoCobertura
        let valorRendaMensal

        indexAux = indexPDFAvulso(linhasPDFTxt, ' Cobertura Ramo Capital segurado (R$) Data de fim de vigência', 0) + 1

        while (
            linhasPDFTxt[indexAux] !==
            'As Coberturas contratadas terão seu início e término de vigência às 24 horas das datas acima indicadas.'
        ) {

            achou = false

            indexIntegracao = 0

            while (indexIntegracao < linhaIntegracao.cobertura2.length) {

                const linhaCobertura = linhaIntegracao.cobertura2[indexIntegracao]

                if (!achou) {

                    if (linhasPDFTxt[indexAux].substring(0, linhaCobertura.chave.length) === linhaCobertura.chave) {

                        descricaoCobertura = linhaCobertura.descricaoCobertura

                        if (!descricaoCobertura) {

                            descricaoCobertura =
                                trataTexto(linhasPDFTxt[indexAux - 2] + ' ' + linhasPDFTxt[indexAux - 1] + ' (' + linhaCobertura.chave + ')')
                        }

                        let inicioValorCS

                        if (linhaCobertura.proximaLinha) {

                            inicioValorCS = 0
                            indexAux++

                        } else {

                            inicioValorCS = linhaCobertura.chave.length
                        }

                        valorCS =
                            trataValorTexto(
                                linhasPDFTxt[indexAux].substring(
                                    inicioValorCS,
                                    linhasPDFTxt[indexAux].indexOf(espaco, inicioValorCS + 1)
                                )
                            )

                        if (linhasPDFTxt[indexAux].substring(linhasPDFTxt[indexAux].length - 9) === 'Vitalício') {

                            dataTerminoCobertura =
                                dataAnoMesDia(
                                    ano(jsonRegistros.jsonRegistros[indexJsonRegistros].nascimentoSeguradoCliente) + 100/* - 1*/,
                                    mes(jsonRegistros.jsonRegistros[indexJsonRegistros].dataEmissao),
                                    dia(jsonRegistros.jsonRegistros[indexJsonRegistros].dataEmissao)
                                )

                        } else {

                            dataTerminoCobertura = trataData(linhasPDFTxt[indexAux].substring(linhasPDFTxt[indexAux].length - 10))
                        }

                        incluiCoberturas(coberturas, numeroCobertura, codigoCobertura, descricaoCobertura,
                            linhaCobertura.tipoCoberturaSeguroVida, statusCobertura, valorCS, valorPremioLiquido, valorIof,
                                valorPremio, classeAjusteRisco, valorPremioExtra, duracaoPremioExtra, dataTerminoCobertura,
                                    valorRendaMensal)
                            
                        coberturas[coberturas.length - 1].id = linhaCobertura.id

                        achou = true
                    }
                }

                indexIntegracao++
            }
            
            jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas = coberturas

            indexAux++
        }



        indexAux = indexPDFAvulso(linhasPDFTxt, 'multiplicativo', indexAux) + 1

        while (linhasPDFTxt[indexAux] !== 'Prêmio de referência do mês de emissão desta apólice.') {

            achou = false

            indexIntegracao = 0

            while (indexIntegracao < linhaIntegracao.premio2.length) {

                const linhaPremio = linhaIntegracao.premio2[indexIntegracao]

                if (!achou) {

                    if (linhasPDFTxt[indexAux].substring(0, linhaPremio.chave.length) === linhaPremio.chave) {

                        let linha

                        if (linhaPremio.linha === 0) {

                            linha = linhasPDFTxt[indexAux].substring(linhaPremio.chave.length + 1)

                        } else {

                            linha = linhasPDFTxt[indexAux + linhaPremio.linha]
                        }

                        linha = linha.split(espaco)

                        const indexCobertura = pesquisaIndexList(coberturas, linhaPremio.id)

                        coberturas[indexCobertura].valorPremioLiquido = trataValorTexto(linha[0])
                        coberturas[indexCobertura].valorIof = trataValorTexto(linha[1])
                        coberturas[indexCobertura].valorPremio = trataValorTexto(linha[2])

                        achou = true
                    }
                }

                indexIntegracao++
            }
            
            jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas = coberturas

            indexAux++
        }
    }



    jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)
    
    return jsonRegistros.jsonRegistros
}



export const importaListaApolicesMetLife = (XLSX, idUsuarioLogado, vars, equipeList, linhaIntegracao, seguradora,
    nomeArquivo, erros, variaveisGlobais) => {

    //const timeSeguradoraAux = timeSeguradora(idUsuarioLogado, equipeList, seguradora)

    let jsonRegistros = jsonRegistrosInicializacao()

    let linha = linhaIntegracao.cabecalho + 1

    while (linha < XLSX.length) {

        if (XLSX[linha][0]) {

            jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

            

            //const usuarioClienteSelecionado = idUsuarioLogado//idAgenteTimeSeguradora(timeSeguradoraAux, XLSX[linha][38])

            const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

           

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoNumeroProposta, true, null, erros, nomeArquivo)
            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 9, HARDCODE.importacaoNumeroApolice, true, null, erros, nomeArquivo)
            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 8, HARDCODE.importacaoStatusApolice, true, linhaIntegracao.statusApolice,
                erros, nomeArquivo)

            if (jsonRegistros.jsonRegistros[indexJsonRegistros].statusApolice === HARDCODE.idStatusApoliceCancelada) {

                obtemDadoXLSX(XLSX, jsonRegistros, linha, 37, HARDCODE.importacaoDataCancelamento,
                    false, null, erros, nomeArquivo)

            } else {

                jsonRegistros.jsonRegistros[indexJsonRegistros].dataCancelamento = ''
            }

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 45, HARDCODE.importacaoDataEmissao, true, null, erros, nomeArquivo)
            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 0, HARDCODE.importacaoNomeSeguradoCliente, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 2, HARDCODE.importacaoCpfSeguradoCliente, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 3, HARDCODE.importacaoNascimentoSeguradoCliente, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 4, HARDCODE.importacaoSexoSeguradoCliente, true, null, erros, nomeArquivo)
            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoProfissaoSegurado, true, null, erros, nomeArquivo)
            


            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoEnderecoSeguradoCliente, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].enderecoSeguradoCliente = XLSX[linha][?] // tamanho maior que o normal de um endereço

            //if (jsonRegistros.jsonRegistros[indexJsonRegistros].enderecoSeguradoCliente) {

            //    jsonRegistros.jsonRegistros[indexJsonRegistros].enderecoSeguradoCliente =
            //        jsonRegistros.jsonRegistros[indexJsonRegistros].enderecoSeguradoCliente.replace('CEP:' + espaco, '')

            //    const endereco = jsonRegistros.jsonRegistros[indexJsonRegistros].enderecoSeguradoCliente.split('-')

            //    const tamEndereco = endereco.length

            //    jsonRegistros.jsonRegistros[indexJsonRegistros].cepSeguradoCliente = endereco[tamEndereco - 2].trim()
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].ufSeguradoCliente = endereco[tamEndereco - 3].trim()
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].cidadeSeguradoCliente = endereco[tamEndereco - 4].trim()
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].bairroSeguradoCliente = endereco[tamEndereco - 5].trim()
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].complementoEnderecoSeguradoCliente = endereco[tamEndereco - 6].trim()
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].numeroEnderecoSeguradoCliente = endereco[tamEndereco - 7].trim()

            //    if (tamEndereco === 10) {
                    
            //        jsonRegistros.jsonRegistros[indexJsonRegistros].enderecoSeguradoCliente =
            //            endereco[0].trim() + espaco + endereco[1].trim() + '-' + endereco[2].trim()

            //    } else {

            //        jsonRegistros.jsonRegistros[indexJsonRegistros].enderecoSeguradoCliente =
            //            endereco[0].trim() + espaco + endereco[1].trim()
            //    }
            //}



            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoCelularSeguradoCliente, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoEmailSeguradoCliente, false, null, erros, nomeArquivo)
            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoRendaMensal, false/*true*/, null, erros, nomeArquivo)
           
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 24, HARDCODE.importacaoTipoPeriodicidadePagtoPremio, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 21, HARDCODE.importacaoTipoFormaPagtoPremio, true, null, erros, nomeArquivo)
            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 25, HARDCODE.importacaoDiaVencimento, true, null, erros, nomeArquivo)
            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoCnpjEmpresa, true, null, erros, nomeArquivo)

            //jsonRegistros.jsonRegistros[indexJsonRegistros].cnpjEmpresa =
            //    converterCnpjEmpresa(vars, jsonRegistros.jsonRegistros[indexJsonRegistros].cnpjEmpresa)


            
            //if (usuarioClienteSelecionado) {
               
                //jsonRegistros.jsonRegistros[indexJsonRegistros].usuarioClienteSelecionado = usuarioClienteSelecionado
            
                const coberturas = []

                let valorPremioAnualizado = 0
                let prazoPagto = ''

                while (linha < XLSX.length && '' + XLSX[linha][9] === jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice) {

                    valorPremioAnualizado = round(valorPremioAnualizado + XLSX[linha][14], 2)

                    let numeroCobertura
                    let codigoCobertura
                    let descricaoCobertura
                    let tipoCoberturaSeguroVida
                    let valorCS
                    let valorPremioLiquido
                    let valorIof
                    let valorPremio
                    let classeAjusteRisco
                    let valorPremioExtra
                    let duracaoPremioExtra
                    let dataTerminoCobertura
                    let valorRendaMensal

                    prazoPagto = XLSX[linha][7].split(espaco)
                    if (prazoPagto[prazoPagto.length - 2] === 'SINGULAR') {

                        prazoPagto = 1

                    } else {

                        prazoPagto = parseInt(prazoPagto[prazoPagto.length - 1])
                    }

                    tipoCoberturaSeguroVida = identificaTipoCoberturaSeguroVida(XLSX[linha][7] + ' - ' + XLSX[linha][13], linhaIntegracao,
                        jsonRegistros.jsonRegistros[indexJsonRegistros], nomeArquivo, erros)

                    if (tipoCoberturaSeguroVida) {

                        //numeroCobertura = XLSX[linha][?]
                        //codigoCobertura = XLSX[linha][?].substring(XLSX[linha][?].length - 4)
                        descricaoCobertura = trataTexto(XLSX[linha][13])
                        valorCS = XLSX[linha][18]
                        //valorPremioLiquido = XLSX[linha][?]
                        //valorIof = XLSX[linha][?]
                        //valorPremio = round(valorPremioLiquido + valorIof, 2)
                        valorPremio = XLSX[linha][14]

                        //if (XLSX[linha][?]) {

                        //   dataTerminoCobertura = trataData(XLSX[linha][?])

                        //} else {

                        //    dataTerminoCobertura = dataAnoMesDia(
                        //        ano(jsonRegistros.jsonRegistros[indexJsonRegistros].nascimentoSeguradoCliente) + 100/* - 1*/,
                        //        mes(jsonRegistros.jsonRegistros[indexJsonRegistros].dataEmissao),
                        //        dia(jsonRegistros.jsonRegistros[indexJsonRegistros].dataEmissao)
                        //    )
                        //}

                        const statusCobertura = ''//identificaStatusCobertura(trataTexto(XLSX[linha][28/*24*/]), linhaIntegracao,
                        //    jsonRegistros.jsonRegistros[indexJsonRegistros], nomeArquivo, erros)

                        incluiCoberturas(coberturas, numeroCobertura, codigoCobertura, descricaoCobertura, tipoCoberturaSeguroVida,
                            statusCobertura, valorCS, valorPremioLiquido, valorIof, valorPremio,
                                classeAjusteRisco, valorPremioExtra, duracaoPremioExtra, dataTerminoCobertura, valorRendaMensal)

                        //if (!prazoPagto) {

                        //    prazoPagto = XLSX[linha][21]

                        //    if (!prazoPagto) {

                        //        prazoPagto = XLSX[linha][23]
                        //    }
                        //}
                    }

                    linha++
                }

                //jsonRegistros.jsonRegistros[indexJsonRegistros].valorPremioAnualizado = valorPremioAnualizado
                jsonRegistros.jsonRegistros[indexJsonRegistros].valorPremioAnualizado = 
                    calculaValorAnual(valorPremioAnualizado,
                        jsonRegistros.jsonRegistros[indexJsonRegistros].tipoPeriodicidadePagtoPremio) 

                //if (!prazoPagto && vars.idConfiguracao === 'e287b929-9ef8-4062-9d81-b32ad9145224' /*MESSEM FAMI*/) {

                //    prazoPagto = 10
                //}

                jsonRegistros.jsonRegistros[indexJsonRegistros].prazoPagto = prazoPagto

                jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas = coberturas

            //} else {

            //    erros.push(MESSAGE().agenteNaoEncontradoApolice
            //        .replace("$numeroApolice$", jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice)
            //            .replace("$codigoAgente$", XLSX[linha][38])
            //    )

            //    linha++
            //}

            jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)

        } else {

            linha++
        }
    }

    return jsonRegistros.jsonRegistros
}


export const importaListaApolicesMetLifeImplantacao = (XLSX, idUsuarioLogado, vars, equipeList, linhaIntegracao, seguradora,
    nomeArquivo, erros, variaveisGlobais) => {

    const timeSeguradoraAux = timeSeguradora(idUsuarioLogado, equipeList, seguradora)

    let jsonRegistros = jsonRegistrosInicializacao()

    let linha = linhaIntegracao.cabecalho + 1

    while (linha < XLSX.length) {

        if (XLSX[linha][0]) {

            jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

            

            const usuarioClienteSelecionado = idAgenteTimeSeguradora(timeSeguradoraAux, XLSX[linha][38])

            const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

           

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 6, HARDCODE.importacaoNumeroApolice, true, null, erros, nomeArquivo)
            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 5, HARDCODE.importacaoStatusApolice, true, linhaIntegracao.statusApolice,
                erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 41, HARDCODE.importacaoDataEmissao, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 0, HARDCODE.importacaoNomeSeguradoCliente, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 43, HARDCODE.importacaoCpfSeguradoCliente, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 44, HARDCODE.importacaoNascimentoSeguradoCliente, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 45, HARDCODE.importacaoSexoSeguradoCliente, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 20, HARDCODE.importacaoTipoPeriodicidadePagtoPremio, true, null, erros, nomeArquivo)
            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 10, HARDCODE.importacaoValorPremioAnualizado, true, null, erros, nomeArquivo)
            
            jsonRegistros.jsonRegistros[indexJsonRegistros].valorPremioAnualizado = 
                calculaValorAnual(jsonRegistros.jsonRegistros[indexJsonRegistros].valorPremioAnualizado,
                    jsonRegistros.jsonRegistros[indexJsonRegistros].tipoPeriodicidadePagtoPremio) 

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 17, HARDCODE.importacaoTipoFormaPagtoPremio, true, null, erros, nomeArquivo)


            
            if (usuarioClienteSelecionado) {
               
                jsonRegistros.jsonRegistros[indexJsonRegistros].usuarioClienteSelecionado = usuarioClienteSelecionado
    
            } else {
        
                erros.push(MESSAGE().agenteNaoEncontradoApolice
                    .replace("$numeroApolice$", jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice)
                        .replace("$codigoAgente$", XLSX[linha][38])
                )
            }

            jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)
        }

        linha++
    }
    

    return jsonRegistros.jsonRegistros
}



/*
export const importaApoliceMetLifeNovoLayout = (PDFTxt, idUsuarioLogado, vars, equipeList, linhaIntegracao, seguradora,
    nomeArquivo, erros, variaveisGlobais) => {

    const jsonRegistros = jsonRegistrosInicializacao()

    jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

    const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

    PDFTxt = PDFTxt.replaceAll(fimLinha + 'Morte Com Capital Segurado' + espaco + fimLinha +
        'Decrescente A Cada Ano' + espaco,
            fimLinha + 'Morte Com Capital Segurado Decrescente A Cada Ano' + espaco)

    PDFTxt = PDFTxt.replaceAll(fimLinha + 'Invalidez Total Ou Parcial Por' + espaco + fimLinha +
        'Acidente' + espaco,
            fimLinha + 'Invalidez Total Ou Parcial Por Acidente' + espaco)


    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Cobertura(s) e capital(is) segurado(s) individual(is)' + fimLinha +
        'Cobertura Ramo Capital segurado (R$)' + fimLinha + 'Data de fim de' + espaco + fimLinha + 'vigência' + fimLinha +
            'Período de' + espaco + fimLinha + 'vigência' + fimLinha,
                fimLinha + 'As Coberturas contratadas terão seu início e término de vigência às 24 horas das datas acima indicadas.' +
                    espaco + fimLinha, HARDCODE.importacaoCoberturas, false, null, erros, nomeArquivo)

    //const coberturas1 = jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas.split(fimLinha)
    //console.log(coberturas1)



    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Nome do segurado Data de nascimento CPF' + fimLinha, fimLinha,
        HARDCODE.importacaoLinhaDados, true, null, erros, nomeArquivo)

    let linhaDados = jsonRegistros.jsonRegistros[indexJsonRegistros].linhaDados.split(espaco)
    let tamLinhaDados = linhaDados.length

    obtemDadoPDFAvulso(jsonRegistros, linhaDados[tamLinhaDados - 1],
        HARDCODE.importacaoCpfSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDFAvulso(jsonRegistros, linhaDados[tamLinhaDados - 2],
        HARDCODE.importacaoNascimentoSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDFAvulso(jsonRegistros, obtemTextoArray(linhaDados, 0, tamLinhaDados - 3),
        HARDCODE.importacaoNomeSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Endereço completo Nº Complemento' + fimLinha, fimLinha,
        HARDCODE.importacaoEnderecoSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Bairro CEP Cidade UF' + fimLinha, fimLinha,
        HARDCODE.importacaoLinhaDados, true, null, erros, nomeArquivo)

    linhaDados = jsonRegistros.jsonRegistros[indexJsonRegistros].linhaDados.split(espaco)
    tamLinhaDados = linhaDados.length

    obtemDadoPDFAvulso(jsonRegistros, linhaDados[tamLinhaDados - 1],
        HARDCODE.importacaoUfSeguradoCliente, true, null, erros, nomeArquivo)

    const indexCep = indexCampoComecaTerminaComNumero(linhaDados)

    obtemDadoPDFAvulso(jsonRegistros, linhaDados[indexCep],
        HARDCODE.importacaoCepSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDFAvulso(jsonRegistros, obtemTextoArray(linhaDados, 0, indexCep - 1),
        HARDCODE.importacaoBairroSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDFAvulso(jsonRegistros, obtemTextoArray(linhaDados, indexCep + 1, linhaDados.length - 2),
        HARDCODE.importacaoCidadeSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Nº da proposta:' + espaco, espaco,
        HARDCODE.importacaoNumeroProposta, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, espaco + 'Nº da apólice:' + espaco, fimLinha,
        HARDCODE.importacaoNumeroApolice, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, espaco + 'Periodicidade de pagamento dos prêmios:' + espaco, fimLinha,
        HARDCODE.importacaoTipoPeriodicidadePagtoPremio, true, null, erros, nomeArquivo)
    //
    //console.log(jsonRegistros.jsonRegistros[indexJsonRegistros])



    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Telefone' + fimLinha, fimLinha,
        HARDCODE.importacaoCelularSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Email' + fimLinha, fimLinha,
        HARDCODE.importacaoEmailSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Sexo' + fimLinha, fimLinha,
        HARDCODE.importacaoSexoSeguradoCliente, true, null, erros, nomeArquivo)
    
    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Profissão' + fimLinha, fimLinha, 
        HARDCODE.importacaoProfissaoSegurado, false, null, erros, nomeArquivo)

  

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Número' + fimLinha, fimLinha,
        HARDCODE.importacaoNumeroEnderecoSeguradoCliente, true, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Complemento' + fimLinha, fimLinha + '03 Dados da apólice' + fimLinha,
        HARDCODE.importacaoComplementoEnderecoSeguradoCliente, false, null, erros, nomeArquivo)

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Status da Apólice:' + espaco, fimLinha,
        HARDCODE.importacaoStatusApolice, true, linhaIntegracao.statusApolice, erros, nomeArquivo)

    

    obtemDadoPDF(PDFTxt, jsonRegistros, espaco + 'do dia' + espaco, fimLinha, 
        HARDCODE.importacaoDataEmissao, true, null, erros, nomeArquivo)

   

    const linhasCobertura = []
    let indexLinhasCobertura = 0

    const linhasCoberturaAux = jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas.split(fimLinha)
    let indexLinhasPosicaoAux = 0
    let linhaCoberturaAux = ''

    const coberturas = []

    let dadosCobertura
    let indexDadosCobertura

    let numeroCobertura
    let codigoCobertura
    let descricaoCobertura
    let tipoCoberturaSeguroVida
    let valorCS
    let valorPremioLiquido
    let valorIof
    let valorPremio
    let classeAjusteRisco
    let valorPremioExtra
    let duracaoPremioExtra
    let dataTerminoCobertura
    let valorRendaMensal

    while (indexLinhasPosicaoAux < linhasCoberturaAux.length) {

        if (linhasCoberturaAux[indexLinhasPosicaoAux].indexOf('/') === -1) {

            linhaCoberturaAux = espacoAntes(linhaCoberturaAux, linhasCoberturaAux[indexLinhasPosicaoAux])

        } else {

            linhasCobertura.push(espacoAntes(linhaCoberturaAux, linhasCoberturaAux[indexLinhasPosicaoAux]))

            linhaCoberturaAux = ''
        }

        indexLinhasPosicaoAux += 1
    }

    while (indexLinhasCobertura < linhasCobertura.length) {

        dadosCobertura = linhasCobertura[indexLinhasCobertura].split(espaco)

        indexDadosCobertura = 0

        descricaoCobertura = ''

        while (indexDadosCobertura < dadosCobertura.length && dadosCobertura[indexDadosCobertura] !== 'R$') {

            descricaoCobertura += (descricaoCobertura ? espaco : '') + dadosCobertura[indexDadosCobertura]

            indexDadosCobertura++
        }

        tipoCoberturaSeguroVida = identificaTipoCoberturaSeguroVida(descricaoCobertura, linhaIntegracao,
            jsonRegistros.jsonRegistros[indexJsonRegistros], nomeArquivo, erros)

        valorCS = trataValorTexto(dadosCobertura[indexDadosCobertura + 1])
        valorPremio = trataValorTexto(dadosCobertura[indexDadosCobertura + 5])

        dataTerminoCobertura = trataData(dadosCobertura[indexDadosCobertura + 6])

        incluiCoberturas(coberturas, numeroCobertura, codigoCobertura, descricaoCobertura, tipoCoberturaSeguroVida,
            HARDCODE.idStatusCoberturaAtivaPagandoPremio, valorCS, valorPremioLiquido, valorIof, valorPremio,
                classeAjusteRisco, valorPremioExtra, duracaoPremioExtra, dataTerminoCobertura, valorRendaMensal)
        
        indexLinhasCobertura++
    }

    jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas = coberturas


    
    jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)



    return jsonRegistros.jsonRegistros
}
*/



export const importaListaComissoesMetLife = (XLSX, idUsuarioLogado, vars, equipeList, linhaIntegracao, seguradora,
    nomeArquivo, erros, variaveisGlobais) => {

    let jsonRegistros = jsonRegistrosInicializacao()

    let linha = linhaIntegracao.cabecalho + 1

    while (linha < XLSX.length) {

        if (XLSX[linha][0] && XLSX[linha][3] === 'VIDA INDIVIDUAL') {

            jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

            //const usuarioClienteSelecionado = idAgenteTimeSeguradora(timeSeguradoraAux, XLSX[linha][30])

            const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)

            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 1, HARDCODE.importacaoCpfSeguradoCliente, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 8, HARDCODE.importacaoNumeroProposta, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 4, HARDCODE.importacaoNumeroApolice, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].numeroProposta
            jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice =
                jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice.replace('91.', '')
            jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice =
                '' + parseInt(jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 9, HARDCODE.importacaoNumeroParcela, true, null, erros, nomeArquivo)
            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 9, HARDCODE.importacaoNumeroParcelaFaturada, false, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoTipoPeriodicidadePagtoPremio, true, null, erros, nomeArquivo)
            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 35, HARDCODE.importacaoTipoFormaPagtoPremio, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 18, HARDCODE.importacaoDataGeracaoComissao, true, null, erros, nomeArquivo)
            
            obtemDadoXLSX(XLSX, jsonRegistros, linha, 14, HARDCODE.importacaoValorBaseCalculoComissao, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 20, HARDCODE.importacaoPercAngariacao, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].percAngariacao =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percAngariacao * 100

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 19, HARDCODE.importacaoValorAngariacao, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 12, HARDCODE.importacaoPercComissao, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].percComissao =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percComissao * 100

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 13, HARDCODE.importacaoValorComissao, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 24, HARDCODE.importacaoPercEstorno, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].percEstorno =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percEstorno * 100

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 23, HARDCODE.importacaoValorEstorno, true, null, erros, nomeArquivo)
            if (jsonRegistros.jsonRegistros[indexJsonRegistros].valorComissao < 0) {

                jsonRegistros.jsonRegistros[indexJsonRegistros].valorBaseCalculoComissao =
                    jsonRegistros.jsonRegistros[indexJsonRegistros].valorBaseCalculoComissao * -1

                jsonRegistros.jsonRegistros[indexJsonRegistros].percEstorno =
                    jsonRegistros.jsonRegistros[indexJsonRegistros].percComissao
                jsonRegistros.jsonRegistros[indexJsonRegistros].valorEstorno =
                    jsonRegistros.jsonRegistros[indexJsonRegistros].valorComissao * -1

                jsonRegistros.jsonRegistros[indexJsonRegistros].percComissao = 0
                jsonRegistros.jsonRegistros[indexJsonRegistros].valorComissao = 0
            }

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoPercComissaoCoCorretagem, false, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoValorComissaoCoCorretagem, false, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 26, HARDCODE.importacaoPercIncentivo, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].percIncentivo =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percIncentivo * 100

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 25, HARDCODE.importacaoValorIncentivo, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 28, HARDCODE.importacaoPercBonificacao, true, null, erros, nomeArquivo)
            //jsonRegistros.jsonRegistros[indexJsonRegistros].percBonificacao =
            //    jsonRegistros.jsonRegistros[indexJsonRegistros].percBonificacao * 100

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 27, HARDCODE.importacaoValorBonificacao, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 9, HARDCODE.importacaoCodigoCobertura, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, 8, HARDCODE.importacaoDescricaoCobertura, true, null, erros, nomeArquivo)
            
            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoValorComissaoTotal, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoNumeroCobertura, true, null, erros, nomeArquivo)

            //obtemDadoXLSX(XLSX, jsonRegistros, linha, ?, HARDCODE.importacaoAgentesComissao, true, null, erros, nomeArquivo)

            obtemDadoXLSX(XLSX, jsonRegistros, linha, 16, HARDCODE.importacaoCnpjEmpresa, true, null, erros, nomeArquivo)

            jsonRegistros.jsonRegistros[indexJsonRegistros].cnpjEmpresa =
                converterCnpjEmpresa(vars, jsonRegistros.jsonRegistros[indexJsonRegistros].cnpjEmpresa)

            //if (usuarioClienteSelecionado) {
               
            //        jsonRegistros.jsonRegistros[indexJsonRegistros].usuarioClienteSelecionado = usuarioClienteSelecionado
                 
            //} else {
        
            //    erros.push(MESSAGE().agenteNaoEncontradoApolice
            //        .replace("$numeroApolice$", jsonRegistros.jsonRegistros[indexJsonRegistros].numeroApolice)
            //            .replace("$codigoAgente$", XLSX[linha][30])
            //    )
            //}

            jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)
        }

        linha++
    }
    

    return jsonRegistros.jsonRegistros
}



export const importaCotacaoMetLifeTabelaEvolucaoValorResgate = (values, item, linhaIntegracaoCotacao,
    PDFTxt, nomeArquivo, erros) => {

    const jsonRegistros = jsonRegistrosInicializacao()

    jsonRegistros.jsonRegistros.push(jsonRegistrosJsonRegistrosInicializacao(erros))

    const indexJsonRegistros = indexAtualJsonRegistros(jsonRegistros)
    //console.log(PDFTxt)

    

    let modelo

    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Data que a primeira cotação foi gerada:' + espaco, fimLinha,
        HARDCODE.importacaoDataCotacao, false, null, erros, nomeArquivo)
        
    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Capital Segurado:' + espaco, fimLinha,
        HARDCODE.importacaoValorCS, true, null, erros, nomeArquivo)
        
    if (jsonRegistros.jsonRegistros[indexJsonRegistros].dataCotacao) {

        modelo = 1

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Prolongado' + fimLinha, fimLinha + 'Data da simulação:' + espaco,
            HARDCODE.importacaoTabelaEvolucaoValorResgate, true, null, erros, nomeArquivo)

    } else {

        modelo = 2
        
        jsonRegistros.indexInicial = 0

        obtemDadoPDF(PDFTxt, jsonRegistros,
            fimLinha + 'Pagamento Capital Segurado (R$) Prêmio Mensal (R$) Prêmio Anual (R$)' + fimLinha,
                /*fimLinha + */'IOF Total' + fimLinha, HARDCODE.importacaoCoberturas, true, null, erros, nomeArquivo)

        let coberturasAux = jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas

        obtemDadoPDF(PDFTxt, jsonRegistros,
            fimLinha + 'Pagamento Capital Segurado (R$) Prêmio Mensal (R$) Prêmio Anual (R$)' + fimLinha,
                fimLinha + 'Período de Pagamento e Cobertura' + fimLinha,
                    HARDCODE.importacaoCoberturas, true, null, erros, nomeArquivo)

        let coberturasAuxLength = jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas.length

        if (jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas.substring(coberturasAuxLength - 5) === 'MORTE') {

            jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas =
                jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas.substring(0, coberturasAuxLength - 5)
        }

        jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas =
            (jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas.indexOf('VITALÍCIO') !== -1
                ?
                    'VIDA TOTAL'
                :
                    'MORTE TEMPORÁRIA'
            ) + espaco + jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas + 
                (coberturasAux ? fimLinha + coberturasAux : '')

        obtemDadoPDF(PDFTxt, jsonRegistros,
            fimLinha + 'Período de cobertura Período de pagamento Idade do cliente' + fimLinha + 'IdadeAno', fimLinha +
                'As informações indicadas neste formulário são simulações, não constituem compromisso ou responsabilidade entre ambas as partes,' + fimLinha,
                    HARDCODE.importacaoTabelaEvolucaoValorResgate, false, null, erros, nomeArquivo)
                    
        if (!jsonRegistros.jsonRegistros[indexJsonRegistros].tabelaEvolucaoValorResgate) {

            obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Período onde a renovação é permitida Período de cobertura Período de pagamento Idade do cliente' +
                fimLinha + 'IdadeAno', fimLinha +
                    'As informações indicadas neste formulário são simulações, não constituem compromisso ou responsabilidade entre ambas as partes,' + fimLinha,
                        HARDCODE.importacaoTabelaEvolucaoValorResgate, false, null, erros, nomeArquivo)

            if (!jsonRegistros.jsonRegistros[indexJsonRegistros].tabelaEvolucaoValorResgate) {

                obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Período de cobertura Idade do cliente' +
                    fimLinha + 'IdadeAno', fimLinha +
                        'As informações indicadas neste formulário são simulações, não constituem compromisso ou responsabilidade entre ambas as partes,' + fimLinha,
                            HARDCODE.importacaoTabelaEvolucaoValorResgate, false, null, erros, nomeArquivo)

                if (!jsonRegistros.jsonRegistros[indexJsonRegistros].tabelaEvolucaoValorResgate) {

                    obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Período onde a renovação é permitida Período de pagamento Idade do cliente' +
                        fimLinha + 'IdadeAno', fimLinha +
                            'As informações indicadas neste formulário são simulações, não constituem compromisso ou responsabilidade entre ambas as partes,' + fimLinha,
                                HARDCODE.importacaoTabelaEvolucaoValorResgate, false, null, erros, nomeArquivo)

                    if (!jsonRegistros.jsonRegistros[indexJsonRegistros].tabelaEvolucaoValorResgate) {

                        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Período de pagamento Período de cobertura Idade do cliente' +
                            fimLinha + 'IdadeAno', fimLinha +
                                'As informações indicadas neste formulário são simulações, não constituem compromisso ou responsabilidade entre ambas as partes,' + fimLinha,
                                    HARDCODE.importacaoTabelaEvolucaoValorResgate, true, null, erros, nomeArquivo)
                    }
                }
            }
        }

        obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Data da simulação:' + espaco, fimLinha,
            HARDCODE.importacaoDataCotacao, false, null, erros, nomeArquivo)

        if (!jsonRegistros.jsonRegistros[indexJsonRegistros].dataCotacao) {

            jsonRegistros.indexInicial -= 1000

            obtemDadoPDF(PDFTxt, jsonRegistros, fimLinha + 'Data da simulação:' + espaco, fimLinha,
                HARDCODE.importacaoDataCotacao, true, null, erros, nomeArquivo)
        }
    }



    let tipoPeriodicidadePagtoPremio
    let coberturas

    if (jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas) {

        const linhasCobertura = agruparLinhasTextoAgrupar(
            jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas.split(fimLinha), ',')
        let indexLinhasCobertura = 0

        coberturas = []

        let dadosCobertura
        let indexDadosCobertura

        let descricaoCobertura
        let tipoCoberturaSeguroVida
        let valorCS
        //let valorPremioLiquido
        //let valorIof
        //let valorPremio
        let valorPremioLiquidoMensal
        let valorPremioLiquidoAnual
        let valorIofMensal
        let valorIofAnual
        let valorPremioMensal
        let valorPremioAnual
        let prazo

        while (indexLinhasCobertura < linhasCobertura.length) {

            dadosCobertura = linhasCobertura[indexLinhasCobertura].split(espaco)

            indexDadosCobertura = 0

            descricaoCobertura = ''

            while (indexDadosCobertura <= dadosCobertura.length - 6) {

                descricaoCobertura += (descricaoCobertura ? espaco : '') + dadosCobertura[indexDadosCobertura]

                indexDadosCobertura++
            }

            tipoCoberturaSeguroVida = identificaTipoCoberturaSeguroVida(descricaoCobertura, linhaIntegracaoCotacao,
                jsonRegistros.jsonRegistros[indexJsonRegistros], nomeArquivo, erros)

            valorCS = trataValorTexto(dadosCobertura[dadosCobertura.length - 3])
            //valorPremio = trataValorTexto(dadosCobertura[indexDadosCobertura + 5])
            valorPremioLiquidoMensal = trataValorTexto(dadosCobertura[dadosCobertura.length - 2])
            valorPremioLiquidoAnual = trataValorTexto(dadosCobertura[dadosCobertura.length - 1])
            valorIofMensal = round(valorPremioLiquidoMensal * HARDCODE.percIofSeguroVida / 100, 2)
            valorIofAnual = round(valorPremioLiquidoAnual * HARDCODE.percIofSeguroVida / 100, 2)
            valorPremioMensal = round(valorPremioLiquidoMensal + valorIofMensal, 2)
            valorPremioAnual = round(valorPremioLiquidoAnual + valorIofAnual, 2)

            prazo = dadosCobertura[dadosCobertura.length - 5]

            coberturas.push(
                {
                    descricaoCobertura: descricaoCobertura,
                    tipoCoberturaSeguroVida: tipoCoberturaSeguroVida,
                    valorCS: valorCS,
                    //valorPremioLiquido: valorPremioLiquido,
                    //valorIof: valorIof,
                    //valorPremio: valorPremio,
                    valorPremioLiquidoMensal: valorPremioLiquidoMensal,
                    valorPremioLiquidoAnual: valorPremioLiquidoAnual,
                    valorIofMensal: valorIofMensal,
                    valorIofAnual: valorIofAnual,
                    valorPremioMensal: valorPremioMensal,
                    valorPremioAnual: valorPremioAnual,
                    prazo: prazo,
                }
            )

            indexLinhasCobertura++
        }

        jsonRegistros.jsonRegistros[indexJsonRegistros].coberturas = coberturas
    }



    const funeralIndividual = PDFTxt.indexOf(fimLinha + 'Funeral Individual' + fimLinha + 'Capital Segurado:' + espaco)

    if (jsonRegistros.jsonRegistros[indexJsonRegistros].tabelaEvolucaoValorResgate) {

        const linhasTabelaEvolucaoValorResgateAux =
            jsonRegistros.jsonRegistros[indexJsonRegistros].tabelaEvolucaoValorResgate.split(fimLinha)
        let indexLinhasTabelaEvolucaoValorResgateAux = 0

        const linhasTabelaEvolucaoValorResgate = []
        let indexLinhasTabelaEvolucaoValorResgate = 0

        let numeroCotacao = numeroCotacaoAutomatico()
        let dataCotacao = jsonRegistros.jsonRegistros[indexJsonRegistros].dataCotacao
        let ano
        let idade
        let valorCS = jsonRegistros.jsonRegistros[indexJsonRegistros].valorCS
        let valorPremioAnualizadoAcumulado
        let valorResgate
        let valorSaldado
        let beneficioProlongado

        item.tabelaEvolucaoValorResgate = []

        let dadosTabelaEvolucaoValorResgate

        while (indexLinhasTabelaEvolucaoValorResgateAux < linhasTabelaEvolucaoValorResgateAux.length) {

            if (
                    '123456789'.indexOf(linhasTabelaEvolucaoValorResgateAux[indexLinhasTabelaEvolucaoValorResgateAux]
                        .substring(0, 1)) !== -1
            ) {

                linhasTabelaEvolucaoValorResgate.push(
                    linhasTabelaEvolucaoValorResgateAux[indexLinhasTabelaEvolucaoValorResgateAux]
                )
            }

            indexLinhasTabelaEvolucaoValorResgateAux++
        }

        let tamanhoPrimeiraLinha

        const ajusteResgate =
            jsonRegistros.jsonRegistros[indexJsonRegistros].tabelaEvolucaoValorResgate.indexOf('RESGATE') === -1 ? 1 : 0

        while (indexLinhasTabelaEvolucaoValorResgate < linhasTabelaEvolucaoValorResgate.length) {

            dadosTabelaEvolucaoValorResgate =
                linhasTabelaEvolucaoValorResgate[indexLinhasTabelaEvolucaoValorResgate].split(espaco)

            if (!tamanhoPrimeiraLinha) {
            
                tamanhoPrimeiraLinha = dadosTabelaEvolucaoValorResgate.length
            }

            ano = Number.parseInt(dadosTabelaEvolucaoValorResgate[0])
            idade = Number.parseInt(dadosTabelaEvolucaoValorResgate[1])
            valorPremioAnualizadoAcumulado = trataValorTexto(dadosTabelaEvolucaoValorResgate[2])
            
            if (ajusteResgate === 0) {
            
                valorResgate = trataValorTexto(dadosTabelaEvolucaoValorResgate[3])
            }

            beneficioProlongado = ''

            if (modelo === 1) {

                valorSaldado = trataValorTexto(dadosTabelaEvolucaoValorResgate[4])

                let indexDadosTabelaEvolucaoValorResgate = 5

                while (indexDadosTabelaEvolucaoValorResgate < dadosTabelaEvolucaoValorResgate.length) {

                    beneficioProlongado +=
                        dadosTabelaEvolucaoValorResgate[indexDadosTabelaEvolucaoValorResgate] + espaco

                    indexDadosTabelaEvolucaoValorResgate++
                }

            } else {
                
                if (PDFTxt.indexOf('Vida Total Singular 5') === -1) {
                    
                    let indexDadosTabelaEvolucaoValorResgate = 4 - ajusteResgate

                    while (
                        indexDadosTabelaEvolucaoValorResgate < dadosTabelaEvolucaoValorResgate.length &&
                        dadosTabelaEvolucaoValorResgate[indexDadosTabelaEvolucaoValorResgate].indexOf(',') === -1
                    ) {

                        beneficioProlongado +=
                            dadosTabelaEvolucaoValorResgate[indexDadosTabelaEvolucaoValorResgate] + espaco

                        indexDadosTabelaEvolucaoValorResgate++
                    }

                    valorSaldado = trataValorTexto(dadosTabelaEvolucaoValorResgate[indexDadosTabelaEvolucaoValorResgate])

                    if (
                            funeralIndividual !== -1 &&
                            dadosTabelaEvolucaoValorResgate.length - 1 > indexDadosTabelaEvolucaoValorResgate + 1
                    ) {

                        if (tamanhoPrimeiraLinha > 15) {

                            indexDadosTabelaEvolucaoValorResgate += 3

                            while (dadosTabelaEvolucaoValorResgate[indexDadosTabelaEvolucaoValorResgate].indexOf(',') === -1) {

                                indexDadosTabelaEvolucaoValorResgate++
                            }

                            if (dadosTabelaEvolucaoValorResgate.length - 1 > indexDadosTabelaEvolucaoValorResgate) {

                                valorPremioAnualizadoAcumulado += trataValorTexto(dadosTabelaEvolucaoValorResgate[indexDadosTabelaEvolucaoValorResgate])
                                valorResgate += trataValorTexto(dadosTabelaEvolucaoValorResgate[indexDadosTabelaEvolucaoValorResgate + 1])
                            }

                        } else {

                            valorPremioAnualizadoAcumulado += trataValorTexto(dadosTabelaEvolucaoValorResgate[indexDadosTabelaEvolucaoValorResgate + 1])
                            valorResgate += trataValorTexto(dadosTabelaEvolucaoValorResgate[indexDadosTabelaEvolucaoValorResgate + 2])
                        }
                    }
                }
            }
            
            beneficioProlongado = beneficioProlongado.trim()

            if (idade <= 100) {

                if (ano === 1) {

                    let somaValorPremioAnual = coberturas[0].valorPremioAnual
                    let ind = 1

                    while (ind <= coberturas.length - 1) {

                        if (
                                coberturas[ind].tipoCoberturaSeguroVida ===
                                    HARDCODE.idTipoCoberturaSeguroVidaAssistenciaFuneral &&
                                coberturas[ind].descricaoCobertura.substring(0, 6) !== 'AMPARO'
                        ) {

                            somaValorPremioAnual += coberturas[ind].valorPremioAnual
                        }

                        ind ++
                    }
                    //console.log(valorPremioAnualizadoAcumulado)
                    //console.log(somaValorPremioAnual)

                    tipoPeriodicidadePagtoPremio =
                        valorPremioAnualizadoAcumulado === somaValorPremioAnual//coberturas[0].valorPremioAnual
                            ?
                                HARDCODE.idTipoPeriodicidadeAnual
                            :
                                HARDCODE.idTipoPeriodicidadeMensal
                }
            
                incluiTabelaEvolucaoValorResgateCoberturaVidaInteira(values, item, numeroCotacao, dataCotacao, ano,
                    idade, valorCS, valorPremioAnualizadoAcumulado, valorResgate, valorSaldado,
                        beneficioProlongado, tipoPeriodicidadePagtoPremio, coberturas)
            }

            indexLinhasTabelaEvolucaoValorResgate++
        }
    }



    
    //jsonRegistrosJsonRegistrosAtualizaErros(jsonRegistros, erros)



    //return jsonRegistros.jsonRegistros
}

export const importaCotacaoMetLifeTabelaEvolucaoValorResgateCartaAdendo = (values, item, linhaIntegracaoCotacao, XLSX) => {

    let linha = linhaIntegracaoCotacao.cabecalho + 1

    let numeroCotacao = numeroCotacaoAutomatico()
    let dataCotacao = dataAtual()
    let ano = 0
    let idade
    let valorCS
    let valorPremioAnualizadoAcumulado
    let valorResgate
    let valorSaldado
    let beneficioProlongado

    item.tabelaEvolucaoValorResgate = []

    while (linha < XLSX.length) {

        if (XLSX[linha][1]) {

            ano++
            idade = XLSX[linha][1]
            valorCS = XLSX[linha][2]
            valorPremioAnualizadoAcumulado =
                !XLSX[linha][4]
                    ?
                        0
                    :
                        XLSX[linha][4]
            valorResgate = XLSX[linha][5]
            valorSaldado = ''
            beneficioProlongado = ''

            incluiTabelaEvolucaoValorResgateCoberturaVidaInteira(values, item, numeroCotacao, dataCotacao, ano, idade, valorCS,
                valorPremioAnualizadoAcumulado, valorResgate, valorSaldado, beneficioProlongado, null, null)
        }

        linha++
    }
}